import React, { useEffect, useRef, useState } from "react";
import {
  CheckBoxInput,
  DateInput,
  FileInput,
  NumberInput,
  RadioInput,
  SelectInput,
  TextAreaInput,
  TextInput,
} from "../../components/common/ui/Inputs";
import Button from "../../components/common/ui/Button";
import Table from "../../components/common/table/Table";
import { history } from "../../_helpers";
import ExcelExport from "../../components/common/ui/Export/ExcelExport";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  inmateAction,
  masterActions,
  publicUserActions,
  authActions,
} from "../../_store";
import CustomLoader from "../../components/common/ui/Loader";
import generateXlsx from "../../components/common/export/generateXlsx";
import inmateInfoSchema, {
  validateInmateInfo,
} from "../../validation/inmateSchema";
import relationShipSchema from "../../validation/relationShipSchema";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication";
import {
  fDate,
  fDateTimeSuffix,
  formatDateTimeAMPM,
  getCurrentDate,
  MinDate,
  Today,
} from "../../utils/formatTime";
import { Popup } from "../../components/common/ui/NotificationModal/Popup";
import inmateMergeSchema from "../../validation/inmateMergeSchema";
import rejectsrc from "../../assets/svg/reject.svg";
import { StoredProcedures } from "../../_helpers/enumerator";
import limitSchema from "../../validation/limitSchema";
import Swal from "sweetalert2";
import useManagementUserAccessPermission from "../../hooks/useManagementUserAccessPermission";

function InmateInfo() {
  const { settingsFrequency } = useSelector((x) => x.dropdownOptions);
  const Inmate_Setting_Access = JSON.parse(process.env.REACT_APP_INMATE_SETTING);
  const [infoCheckBox, setInfoCheckBox] = useState(true);
  const [settingsCheckBox, setSettingsCheckBox] = useState(false);
  const [connectionCheckBox, setConnectionCheckBox] = useState(false);
  const [loginInfoCheckBox, setLoginInfoCheckBox] = useState(false);
  const { PuAccessPermission } = useManagementUserAccessPermission();
  const [isloading, setIsLoading] = useState(false);

  //Getting this InmateID from InmateList Page
  const location = useLocation();
  const {
    inmate: Inmate,
    source,
    publicUserId,
    ActiveStatus,
    row,
  } = location.state || {};
  const dispatch = useDispatch();
  const {
    inmateInfoTabData,
    connectionDataList,
    loading,
    connectionDataFullList,
    loginLogFullHistory,
    loginLogHistory,
    relationShipupdateRes,
    facilityInfodata,
    podInfodata,
    inmateAccessMenuSetting,
    inmateRequestAccessFormData,
    securityQuestion,
    infoTabUpdateRes,
    securityQUpdateRes,
    securityresetRes,
    mergeInmate,
    newmergeInmate,
    inmate,
    mergeRes,
  } = useSelector((x) => x.inmate);
  const { publicUserMessageValue, loading: publicuserLoading } = useSelector(
    (x) => x?.publicUser
  );
  const {
    user,
    commonFacilityCode: facilityCode,
    loading: authLoading,
    isDisabledInmate
  } = useSelector((x) => x.auth);


  const { loading: masterLoading } = useSelector((x) => x.master);

  const { requestStatus, requestFrequency, facilityFrequencyCount } =
    useSelector((x) => x.dropdownOptions);

  const staticRequestFormTypeID = [
    1, 2, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63,
  ];

  useEffect(() => {
    if (
      Object?.keys(publicUserMessageValue)?.length === 0 &&
      (source === "publicUserMesage" || source === "publicUserPhoto")
    ) {
      history.navigate("InmateList");
    }
  }, [publicUserMessageValue, source]);

  useEffect(() => {
    dispatch(authActions.updateisDisabledInmate(Inmate_Setting_Access.includes(user?.UserRoleID) ? false : true))
    // dispatch(inmateAction.clearInmateInfo());
    dispatch(
      masterActions.LoadFacilityDropDown({
        facilityID: 0,
        activeStatus: 1,
      })
    );
  }, [dispatch]);

  useEffect(() => {
    if (Inmate?.InmateID || inmate?.InmateID) {
      setInmateInfo((prev) => ({
        ...prev,
        InmateID: Inmate?.InmateID || inmate?.InmateID,
      }));


      //Get the Tab List
      dispatch(
        inmateAction.InmatesInfoTab(Inmate?.InmateID || inmate?.InmateID)
      );
      setIsLoading(true);
      //Get the facilityInfo
      dispatch(
        inmateAction.GetFacilityInfo(
          Inmate?.facilityID || inmate?.facilityID || facilityCode
        )
      ).then((x) => {
        setIsLoading(false);
      });

      // //get the POD List
      if (Inmate?.PodID || inmate?.PodID) {
        dispatch(inmateAction.GetPODInfo(Inmate?.PodID || inmate?.PodID || 0));
      }

      //get the security questions
      dispatch(
        inmateAction.GetLoadInmateSecurityQuestionSet({
          InmatesID: Inmate?.InmateID || inmate?.InmateID,
          FacilityID: Inmate?.facilityID || inmate?.facilityID || facilityCode,
        })
      );

      //Get the Merge Process dropdown List
      dispatch(
        inmateAction.GetMergeToInmateDisplayDropdown({
          facilityID: Inmate?.facilityID || inmate?.facilityID || facilityCode,
          mergeFromInmateid: Inmate?.InmateID || inmate?.InmateID,
        })
      );

      dispatch(
        inmateAction.LoadMergeToInmateDisplay({
          facilityID: Inmate?.facilityID || inmate?.facilityID || facilityCode,
          mergeFromInmateid: Inmate?.InmateID || inmate?.InmateID,
        })
      );

      //Connection
      // let param = {
      //   InmatesId: Inmate?.InmateID || inmate?.InmateID,
      //   ManagementUserID: user?.ManagementUserID,
      //   PageNo: 1,
      //   RowCountPerPage: 10,
      //   SortField: "",
      // };

      // setConnection(param);
      // dispatch(inmateAction.LoadInmatePublicConnection(param));

      //InmateLoginLogHistory

      // let loginParam = {
      //   InmateResidentId:
      //     Inmate?.InmateResidentID ||
      //     Inmate?.InmateResidentId ||
      //     inmate?.InmateResidentId,
      //   FacilityID: Inmate?.facilityID || inmate?.facilityID || facilityCode,
      //   FirstName: Inmate?.FirstName || inmate?.FirstName || "",
      //   LastName: Inmate?.LastName || inmate?.LastName || "",
      //   PodID: Inmate?.PodID || inmate?.PodID || 0,
      //   KiosksCode: "",
      //   GenderID: 0,
      //   FromDate: "",
      //   ToDate: "",
      //   ActiveStatus: 1,
      //   PageNo: 1,
      //   RowCountPerPage: 10,
      //   SortBy: "",
      // };
      // setLoginInfo(loginParam);
      // dispatch(inmateAction.LoadInmateLoginLogHistory(loginParam));
    }
  }, [Inmate || inmate]);

  useEffect(() => {
    if (infoTabUpdateRes?.IsSucceed === 1) {
      showToastNotification(
        "Inmate Information Updated Successfully",
        "success"
      );
      dispatch(inmateAction.clearInmateUpdateRes());
      dispatch(
        inmateAction.LoadInmateAccessMenuSettings({
          InmatesID: Inmate?.InmateID || inmate?.InmateID,
          FacilityID: Inmate?.facilityID || inmate?.facilityID || facilityCode,
        })
      );

      //Request Access Setting
      dispatch(
        inmateAction.LoadInmateRequestAccessSettings({
          InmatesID: Inmate?.InmateID || inmate?.InmateID,
          FacilityID: Inmate?.facilityID || inmate?.facilityID || facilityCode,
        })
      );

      //Get the Tab List
      dispatch(
        inmateAction.InmatesInfoTab(Inmate?.InmateID || inmate?.InmateID)
      );

      //Get the facilityInfo
      dispatch(
        inmateAction.GetFacilityInfo(
          Inmate?.facilityID || inmate?.facilityID || facilityCode
        )
      );

      // //get the POD List
      if (Inmate?.PodID || inmate?.PodID) {
        dispatch(inmateAction.GetPODInfo(Inmate?.PodID || inmate?.PodID || 0));
      }

      //get the security questions
      dispatch(
        inmateAction.GetLoadInmateSecurityQuestionSet({
          InmatesID: Inmate?.InmateID || inmate?.InmateID,
          FacilityID: Inmate?.facilityID || inmate?.facilityID || facilityCode,
        })
      );
    }
    // else if (securityresetRes?.IsSucceed === -1) {
    //   showToastNotification("CHK", "error");
    // } else if (securityresetRes?.IsSucceed === -2) {
    //   showToastNotification("CHK", "error");
    // }
  }, [infoTabUpdateRes]);

  // Inmate Merge Response
  useEffect(() => {
    if (mergeRes) {
      switch (mergeRes?.IsSucceed) {
        case 1:
          dispatch(
            inmateAction.InmatesInfoTab(Inmate?.InmateID || inmate?.InmateID)
          );
          // Insert Management User Activity Log
          dispatch(
            authActions?.ManagementUserActivityLog({
              ManagementUserID: user?.ManagementUserID,
              facilityID: facilityCode,
              ProcedureName: StoredProcedures?.MergeInmateDetails,
              UserAction: `Inmate Merged(Old Inmate ID - ${mergeInmateFrom.oldInmateId} &New Inmate ID - ${mergeInmateFrom.newInmateId})`,
            })
          );
          showToastNotification(
            "Inmate information merged successfully.",
            "success"
          );
          setMergeInmateFrom((prev) => ({
            ...prev,
            newInmateId: 0,
          }));
          dispatch(inmateAction.clearMergeResponse());
          break;
        case -1:
          showToastNotification("Unable to update.Please try again.", "error");
          dispatch(inmateAction.clearMergeResponse());
          break;
        case -2:
          showToastNotification(
            "From Inmate is not release or not exist.",
            "error"
          );
          dispatch(inmateAction.clearMergeResponse());
          break;
        default:
          showToastNotification("To Inmate is release or not exist.", "error");
          dispatch(inmateAction.clearMergeResponse());
          break;
      }
    }
  }, [mergeRes]);

  useEffect(() => {
    if (securityresetRes === 1) {
      showToastNotification("Security Setup Reset Successfully.", "success");
      dispatch(
        inmateAction.GetLoadInmateSecurityQuestionSet({
          InmatesID: Inmate?.InmateID || inmate?.InmateID,
          FacilityID: Inmate?.facilityID || inmate?.facilityID || facilityCode,
        })
      );
      dispatch(inmateAction.clearsecurityresetRes());
    } else if (securityresetRes === -1) {
      showToastNotification("Security Question Not Updated Yet.", "error");
      dispatch(
        inmateAction.GetLoadInmateSecurityQuestionSet({
          InmatesID: Inmate?.InmateID || inmate?.InmateID,
          FacilityID: Inmate?.facilityID || inmate?.facilityID || facilityCode,
        })
      );
      dispatch(inmateAction.clearsecurityresetRes());
    } else if (securityresetRes === -2) {
      showToastNotification("InmateID or FacilityID Not Valid.", "error");
      dispatch(
        inmateAction.GetLoadInmateSecurityQuestionSet({
          InmatesID: Inmate?.InmateID || inmate?.InmateID,
          FacilityID: Inmate?.facilityID || inmate?.facilityID || facilityCode,
        })
      );
      dispatch(inmateAction.clearsecurityresetRes());
    }
  }, [securityresetRes]);

  useEffect(() => {
    if (securityQUpdateRes === 1) {
      setEditSQ(false);
      setSQindex(null);
      dispatch(inmateAction.clearQSecurityResponse());
      showToastNotification("Updated successfully.", "success");
      dispatch(
        inmateAction.GetLoadInmateSecurityQuestionSet({
          InmatesID: Inmate?.InmateID || inmate?.InmateID,
          FacilityID: Inmate?.facilityID || inmate?.facilityID || facilityCode,
        })
      );
    } else if (securityQUpdateRes === 2) {
      setEditSQ(false);
      setSQindex(null);
      dispatch(inmateAction.clearQSecurityResponse());
      showToastNotification("Updated successfully.", "success");
      dispatch(
        inmateAction.GetLoadInmateSecurityQuestionSet({
          InmatesID: Inmate?.InmateID || inmate?.InmateID,
          FacilityID: Inmate?.facilityID || inmate?.facilityID || facilityCode,
        })
      );
    } else if (securityQUpdateRes === -1) {
      setEditSQ(false);
      setSQindex(null);
      dispatch(inmateAction.clearQSecurityResponse());
      showToastNotification("Something went wrong", "error");
      dispatch(
        inmateAction.GetLoadInmateSecurityQuestionSet({
          InmatesID: Inmate?.InmateID || inmate?.InmateID,
          FacilityID: Inmate?.facilityID || inmate?.facilityID || facilityCode,
        })
      );
    }
  }, [securityQUpdateRes]);

  const [Squestion, setSquestion] = useState([]);
  const [paramSQ, setParamSQ] = useState({
    InmatesId: 0,
    FacilityID: 0,
    SQuestionID: 0,
    Action: 0,
    SQAnswer: "",
    SQuestionsetID: 0,
    SubmittedBy: 0,
    SubmitterID: 0,
  });

  const [inmateInfo, setInmateInfo] = useState({
    InmateID: Inmate?.InmateID || inmate?.InmateID,
    FacilityID: Inmate?.facilityID || inmate?.facilityID || facilityCode,
    MessageAccess: 1,
    PhotoAccess: 1,
    EcardAccess: 1,
    FormReqAccess: 1,
    LawLibraryAccess: 1,
    CommissaryAccess: 1,
    DocumentsAccess: 1,
    PostalMailAccess: 1,
    AllowAccessAnyKiosks: 1,
    AllowKiosksAccess: 1,
    InmateInvitePublicAccess: 1,
    Notes: "",
    InvestigatorEmail: "",
    InmateInvitePublicFrequencyType: 0,
    InmateInvitePublicCount: null,
    InmateLockAccess: [],
    InmateRequestFormPermission: [],
    createdBy: user?.ManagementUserID || 0,
  });

  //This data is for Settings Tab
  const [data, setData] = useState([
    {
      isSelectAll: true, // Indicates this is the "Select All" row
      index: 0,
      menu: "Select / UnSelect All",
      menuId: 0,
      keyAccess: "SelectAll",
      isChecked: true,
      lockAccess: false,
      title: null,
      from: "",
      to: "",
    },
    {
      index: 1,
      menu: "Allow Access to e-mail Messaging",
      keyAccess: "MessageAccess",
      menuId: 1,
      isChecked: true,
      lockAccess: false,
      InmateLockAccessID: 0,
      showField: false,
      title: "To allow the inmate to access the Messages",
      from: "",
      to: "",
    },
    {
      index: 2,
      menu: "Allow Access to Photo",
      keyAccess: "PhotoAccess",
      menuId: 2,
      isChecked: true,
      lockAccess: false,
      InmateLockAccessID: 0,
      showField: false,
      title: "To allow the inmate to access the Photo",
      from: "",
      to: "",
    },
    {
      index: 3,
      menu: "Allow Access to E-Card",
      keyAccess: "EcardAccess",
      menuId: 13, //random menu ID for E-Card
      isChecked: true,
      lockAccess: false,
      InmateLockAccessID: 0,
      showField: false,
      title: "To allow the inmate to access the E-Card",
      from: "",
      to: "",
    },
    {
      index: 4,
      menu: "Allow Access to Request",
      keyAccess: "FormReqAccess",
      menuId: 3,
      isChecked: true,
      lockAccess: false,
      InmateLockAccessID: 0,
      showField: false,
      title: "To allow the inmate to access the Request forms",
      from: "",
      to: "",
    },
    {
      index: 5,
      menu: "Allow Access to Commissary",
      keyAccess: "CommissaryAccess",
      menuId: 5,
      isChecked: true,
      lockAccess: false,
      InmateLockAccessID: 0,
      showField: false,
      title: "To allow the inmate to access the Commissary",
      from: "",
      to: "",
    },
    {
      index: 6,
      menu: "Allow Access to Documents",
      keyAccess: "DocumentsAccess",
      menuId: 4,
      isChecked: true,
      lockAccess: false,
      InmateLockAccessID: 0,
      showField: false,
      title: "To allow the inmate to access the Documents",
      from: "",
      to: "",
    },
    {
      index: 7,
      menu: "Allow Access to Postal Mail",
      keyAccess: "PostalMailAccess",
      menuId: 11,
      isChecked: true,
      lockAccess: false,
      InmateLockAccessID: 0,
      showField: false,
      title: "To allow the inmate to access the Postal mail",
      from: "",
      to: "",
    },
    {
      index: 8,
      menu: "Allow Login From Any Kiosk",
      keyAccess: "AllowAccessAnyKiosks",
      menuId: 33,
      // menuId: 0,
      isChecked: true,
      lockAccess: false,
      InmateLockAccessID: 0,
      showField: false,
      title: "To allow the inmate to login from Any kiosk",
      from: "",
      to: "",
    },
    {
      index: 9,
      menu: "Allow Access to the Law Library",
      keyAccess: "LawLibraryAccess",
      menuId: 6,
      isChecked: true,
      lockAccess: false,
      InmateLockAccessID: 0,
      showField: false,
      title: "To allow the inmate to access the Law library",
      from: "",
      to: "",
    },
    {
      index: 10,
      menu: "Uncheck this box to disable inmate login",
      keyAccess: "AllowKiosksAccess",
      // menuId: 0,
      menuId: 44,
      // isChecked: true,
      lockAccess: false,
      InmateLockAccessID: 0,
      showField: false,
      title: "To Use this option to restrict inmate access to the system",
      from: "",
      to: "",
    },
    {
      index: 11,
      menu: "Allow Inmate to Invite Public User",
      keyAccess: "InmateInvitePublicAccess",
      menuId: 9,
      isChecked: true,
      lockAccess: false,
      InmateLockAccessID: 0,
      showField: false,
      title: "To allow the inmate to send the invitation to the public users",
      from: "",
      to: "",
    },
  ]);

  let updatedData = [...data];

  useEffect(() => {
    if (inmateRequestAccessFormData?.length > 0) {
      let updatedRForm = inmateRequestAccessFormData?.map((item) => {
        return {
          ...item,
          OverrideStatus:
            item.IActiveStatus === 1 || item.IActiveStatus === 2 ? true : false,
        };
      });

      // setInmateInfo({
      //   ...updatedInmateInfo,
      //   InmateRequestFormPermission: updatedRForm,
      // });
      setInmateInfo((prev) => ({
        ...prev,
        InmateRequestFormPermission: updatedRForm,
      }));
    }
  }, [inmateRequestAccessFormData]);

  useEffect(() => {
    if (securityQuestion.length > 0) {
      let updatedSq = securityQuestion?.map((item, i) => ({
        ...item,
        InmateID: Inmate?.InmateID || inmate?.InmateID,
        facilityID: Inmate?.facilityID || inmate?.facilityID,
        QuestionNo: i + 1,
      }));
      setSquestion(updatedSq);
    } else {
      setSquestion([]);
    }
  }, [securityQuestion]);

  //Based on this Condition the Accessible Menus are Shown
  useEffect(() => {
    // Check if `podInfodata` or `facilityInfodata` has keys
    if (
      Object.keys(podInfodata).length > 0 ||
      Object.keys(facilityInfodata).length > 0
    ) {
      const accessMapping = {
        MessageAccess: "IsMessageAcess",
        PhotoAccess: "IsPhotoAccess",
        EcardAccess: "IsEcardAccess",
        FormReqAccess: "IsFormReqAccess",
        CommissaryAccess: "IsCommissaryAccess",
        DocumentsAccess: "IsDocumentsAccess",
        PostalMailAccess: "IsMailScanningAccess",
        AllowAccessAnyKiosks: "IsKS",
        LawLibraryAccess: "IsLawLibraryAccess",
        AllowKiosksAccess: "IsAllowKiosksAccess", //Doubt
        InmateInvitePublicAccess: "IsInmateInvitePublic",
      };

      // Use function form of setData to ensure latest state is used
      setData((prevData) =>
        prevData.map((item) => {
          const accessKey = accessMapping[item.keyAccess];

          const showField =
            item.keyAccess === "AllowKiosksAccess" || // If it's AllowKiosksAccess, show the field by default
              (podInfodata?.[item.keyAccess] === 1 &&
                facilityInfodata?.[accessKey] === 1) ||
              (podInfodata?.[item.keyAccess] === undefined &&
                facilityInfodata?.[accessKey] === 1)
              ? true
              : false;

          return {
            ...item,
            showField,
          };
        })
      );
    }
  }, [facilityInfodata, podInfodata]);

  //set the createdBy value
  useEffect(() => {
    if (user?.ManagementUserID) {
      setInmateInfo((prevInfo) => ({
        ...prevInfo,
        createdBy: user?.ManagementUserID || 0,
      }));
    }
  }, [user]);

  useEffect(() => {
    if (inmateInfoTabData?.length > 0) {
      setInmateInfo((prevInfo) => ({
        ...prevInfo,
        // Preserve existing `InmateRequestFormPermission`
        InmateRequestFormPermission: prevInfo.InmateRequestFormPermission || [],

        // Notes
        Notes: inmateInfoTabData[0]?.Notes || "",
        InvestigatorEmail: inmateInfoTabData[0]?.InvestigatorEmail || "",

        // Inmate Connection Requests setup
        InmateInvitePublicFrequencyType:
          inmateInfoTabData[0]?.InmateInvitePublicFrequencyType,
        InmateInvitePublicCount: inmateInfoTabData[0]?.InmateInvitePublicCount,

        // Field Access
        MessageAccess: inmateInfoTabData[0]?.MessageAccess,
        PhotoAccess: inmateInfoTabData[0]?.PhotoAccess,
        EcardAccess: inmateInfoTabData[0]?.EcardAccess,
        FormReqAccess: inmateInfoTabData[0]?.FormReqAccess,
        LawLibraryAccess: inmateInfoTabData[0]?.LawLibraryAccess,
        CommissaryAccess: inmateInfoTabData[0]?.CommissaryAccess,
        DocumentsAccess: inmateInfoTabData[0]?.DocumentsAccess,
        PostalMailAccess: inmateInfoTabData[0]?.PostalMailAccess,
        AllowAccessAnyKiosks: inmateInfoTabData[0]?.AllowAccessAnyKiosks,
        AllowKiosksAccess: inmateInfoTabData[0]?.AllowKiosksAccess,
        InmateInvitePublicAccess:
          inmateInfoTabData[0]?.InmateInvitePublicAccess,
      }));

      // setData((prevData) =>
      //   prevData.map((item) => ({
      //     ...item,
      //     isChecked: inmateInfoTabData[0][item.keyAccess] === 1 ? true : false,
      //   }))
      // );


      let updatedData = data?.map((item) => ({
        ...item,
        isChecked: inmateInfoTabData[0][item.keyAccess] === 1 ? true : false,
      }));

      // **Check if all menu items (except "Select / UnSelect All") are checked**
      const allChecked = updatedData
        .filter((item) => item.menu !== "Select / UnSelect All")
        .every((item) => item.isChecked);

      // **Update "Select / UnSelect All" checkbox based on allChecked status**
      updatedData = updatedData.map((item) => {
        if (item.menu === "Select / UnSelect All") {
          return { ...item, isChecked: allChecked };
        }
        return item;
      });

      setData(updatedData);
    }
  }, [inmateInfoTabData]);

  let initialdata = [
    {
      isSelectAll: true, // Indicates this is the "Select All" row
      menu: "Select / UnSelect All",
      menuId: 0,
      keyAccess: "SelectAll",
      isChecked: true,
      lockAccess: false,
      title: null,
      from: "",
      to: "",
    },
    {
      menu: "Allow Access to e-mail Messaging",
      keyAccess: "MessageAccess",
      menuId: 1,
      isChecked: true,
      lockAccess: false,
      InmateLockAccessID: 0,
      showField: false,
      title: "To allow the inmate to access the Messages",
      from: "",
      to: "",
    },
    {
      menu: "Allow Access to Photo",
      keyAccess: "PhotoAccess",
      menuId: 2,
      isChecked: true,
      lockAccess: false,
      InmateLockAccessID: 0,
      showField: false,
      title: "To allow the inmate to access the Photos",
      from: "",
      to: "",
    },
    {
      menu: "Allow Access to E-Card",
      keyAccess: "EcardAccess",
      // menuId: 2,
      menuId: 13,
      isChecked: true,
      lockAccess: false,
      InmateLockAccessID: 0,
      showField: false,
      title: "To allow the inmate to access the E-Card",
      from: "",
      to: "",
    },
    {
      menu: "Allow Access to Request",
      keyAccess: "FormReqAccess",
      menuId: 3,
      isChecked: true,
      lockAccess: false,
      InmateLockAccessID: 0,
      showField: false,
      title: "To allow the inmate to access the Request forms",
      from: "",
      to: "",
    },
    {
      menu: "Allow Access to Commissary",
      keyAccess: "CommissaryAccess",
      menuId: 5,
      isChecked: true,
      lockAccess: false,
      InmateLockAccessID: 0,
      showField: false,
      title: "To allow the inmate to access the Commissary",
      from: "",
      to: "",
    },
    {
      menu: "Allow Access to Documents",
      keyAccess: "DocumentsAccess",
      menuId: 4,
      isChecked: true,
      lockAccess: false,
      InmateLockAccessID: 0,
      showField: false,
      title: "To allow the inmate to access the Documents",
      from: "",
      to: "",
    },
    {
      menu: "Allow Access to Postal Mail",
      keyAccess: "PostalMailAccess",
      menuId: 11,
      isChecked: true,
      lockAccess: false,
      InmateLockAccessID: 0,
      showField: false,
      title: "To allow the inmate to access the Postal mail",
      from: "",
      to: "",
    },
    {
      menu: "Allow Login From Any Kiosk",
      keyAccess: "AllowAccessAnyKiosks",
      menuId: 33, // Random ID
      // menuId: 0, // Random ID
      isChecked: true,
      lockAccess: false,
      InmateLockAccessID: 0,
      showField: false,
      title: "To allow the inmate to login from Any kiosk",
      from: "",
      to: "",
    },
    {
      menu: "Allow Access to the Law Library",
      keyAccess: "LawLibraryAccess",
      menuId: 6,
      isChecked: true,
      lockAccess: false,
      InmateLockAccessID: 0,
      showField: false,
      title: "To allow the inmate to access the Law library",
      from: "",
      to: "",
    },
    {
      menu: "Uncheck this box to disable inmate login",
      keyAccess: "AllowKiosksAccess",
      menuId: 44, // Random ID
      // menuId: 0, // Random ID
      isChecked: true,
      lockAccess: false,
      InmateLockAccessID: 0,
      showField: false,
      title: "To Use this option to restrict inmate access to the system",
      from: "",
      to: "",
    },
    {
      menu: "Allow Inmate to Invite Public User",
      keyAccess: "InmateInvitePublicAccess",
      menuId: 9,
      isChecked: true,
      lockAccess: false,
      InmateLockAccessID: 0,
      showField: false,
      title: "To allow the inmate to send the invitation to the public users",
      from: "",
      to: "",
    },
  ];

  useEffect(() => {
    // if (inmateAccessMenuSetting?.length > 0) {
    setInmateInfo((prevInmateInfo) => ({
      ...prevInmateInfo, // Keep all previous properties
      InmateLockAccess:
        inmateAccessMenuSetting?.map((item) => ({
          ...item,
          InmateLockAccessID: 0, // Always set to 0
        })) || [], // Ensure it's not overwritten with undefined
    }));

    // reset issue fix
    //  (reset ? initialdata : prevData).map((item) => {
    setData((prevData) =>
      (prevData).map((item) => {
        const matchingAccess = inmateAccessMenuSetting?.find(
          (access) => item.menuId === access.InmateMenuID
        );

        if (matchingAccess) {
          return {
            ...item,
            InmateLockAccessID: matchingAccess.InmateLockAccessID,
            isChecked: matchingAccess.Status === 1,
            lockAccess: matchingAccess.Status === 1,
            from: matchingAccess.LockAccessFrom,

            to: matchingAccess.LockAccessTo,
          };
        }
        return { ...item, from: "", to: "" }; // after clk the reset btn,existing from and to date is not cleared
      })
    );
    // } else
    if (inmateAccessMenuSetting?.length === 0 && reset === true) {
      if (inmateInfoTabData) {
        setData((prevData) =>
          prevData.map((item) => ({
            ...item,
            // isChecked:
            //   inmateInfoTabData[0][item.keyAccess] === 1 ? true : false,
            lockAccess: false,
            from: "",
            to: "",
          }))
        );
        setInmateInfo((prev) => ({
          ...prev,
          InmateLockAccess: [],
        }));
      }
    }
  }, [inmateAccessMenuSetting]);

  useEffect(() => {
    if (relationShipupdateRes?.IsSucceed === 1) {
      setIsEditing(false);
      showToastNotification("Updated successfully.", "success");
      dispatch(inmateAction.clearRelationShipupdateRes());
      dispatch(inmateAction.LoadInmatePublicConnection(connection));
    } else if (relationShipupdateRes?.IsSucceed == -3) {
      setIsEditing(false);
      showToastNotification("PUIConnectionID not exist", "error");
      dispatch(inmateAction.clearRelationShipupdateRes());
    }
  }, [relationShipupdateRes]);

  const [connection, setConnection] = useState({
    InmatesId: Inmate?.InmateID || inmate?.InmateID,
    ManagementUserID: user?.ManagementUserID,
    PageNo: 1,
    RowCountPerPage: 10,
    SortField: "",
  });

  const [loginInfo, setLoginInfo] = useState({
    InmateResidentId: "",
    FacilityID: Inmate?.facilityID || inmate?.facilityID || facilityCode,
    FirstName: "",
    LastName: "",
    PodID: 0,
    KiosksCode: "",
    GenderID: 0,
    FromDate: "",
    ToDate: "",
    ActiveStatus: 1,
    PageNo: 1,
    RowCountPerPage: 10,
    SortBy: "",
  });

  //Info Data and columns
  const infoData = [
    {
      label: "ID",
      value: inmateInfoTabData[0]?.InmateResidentId || "",
    },
    { label: "First Name", value: inmateInfoTabData[0]?.FirstName || "-" },
    { label: "Middle Name", value: inmateInfoTabData[0]?.MiddleName || "-" },
    { label: "Last Name", value: inmateInfoTabData[0]?.LastName || "-" },
    {
      label: "Pin No",
      value: inmateInfoTabData[0]?.PinNo || "-",
    },
    { label: "Date of Birth", value: inmateInfoTabData[0]?.DOB || "-" },
    {
      label: "Age",
      value: inmateInfoTabData[0]?.Age || "-",
    },
    {
      label: "Gender",
      value: inmateInfoTabData[0]?.Gender || "-",
    },
    { label: "POD", value: inmateInfoTabData[0]?.PodCode || "-" },
    { label: "Status", value: inmateInfoTabData[0]?.InmateStatus || "-" },
  ];

  const columns = [
    {
      name: "Field",
      selector: (row) => row.label,
      sortable: false,
    },
    {
      name: "Value",
      selector: (row) => row.value,
      sortable: false,
    },
  ];

  const [isEditing, setIsEditing] = useState(false);
  const [editValue, setEditValue] = useState({
    PuiConnectionID: row?.PUIConnectionID,
    BeforeModifiedRelationShip: "",
    AterModifiedRelationShip: "",
    ModifiedBy: user?.ManagementUserID,
  });
  let duplicateEditValue = { ...editValue };
  const [index, setIndex] = useState(null);
  const [relationShipErr, setRelationShipErr] = useState({});

  const [isEditSQ, setEditSQ] = useState(false);
  const [sqindex, setSQindex] = useState(null);

  const handleEditChange = (value) => {
    // setEditValue((prev) => ({
    //   ...prev,
    //   AterModifiedRelationShip: value.trimStart(),
    // }));
    duplicateEditValue.AterModifiedRelationShip = value.trimStart();
    setEditValue(duplicateEditValue);
  };

  const handleEditClick = (row, i) => {
    setEditValue((prev) => ({
      ...prev,
      PUIConnectionID: row.PUIConnectionID,
      BeforeModifiedRelationShip: row.RelationShip,
      AterModifiedRelationShip: row.RelationShip,
    }));
    setIndex(i);
    setIsEditing(true);
  };

  const handleConfirmClick = (row) => {
    // setIsEditing(false);
    const error = relationShipSchema(editValue);

    if (error?.error?.details) {
      error?.error?.details.map((e) => {
        const { path } = e;
        setRelationShipErr((prev) => ({
          ...prev,
          [path.join(".")]: e?.message,
        }));

        const className = path.join(".");
        const escapedName = className.replace(/\./g, "\\.");
        const element = document.querySelector(`[name=${escapedName}]`);

        if (element) {
          element.classList.add("input-error", className);
        }
      });

      return;
    }
    dispatch(inmateAction.PUIRelationShipUpdateHistory(editValue));
    // Insert Management User Activity Log
    dispatch(
      authActions?.ManagementUserActivityLog({
        ManagementUserID: user?.ManagementUserID,
        facilityID: facilityCode,
        ProcedureName: StoredProcedures?.PUIRelationShipUpdateHistory,
        UserAction: `Updated Inmate - RelationShip ( PUIConnectionID - ${row?.PUIConnectionID})`,
      })
    );
  };

  const handleCancelClick = () => {
    if (document?.getElementsByClassName("input-error").length > 0) {
      document
        .querySelectorAll(".input-error")
        .forEach((el) => el.classList.remove("input-error"));
    }
    setIsEditing(false);
    setRelationShipErr({});
  };

  const navigatePublicUser = (row) => {
    if (PuAccessPermission[0]?.SubMenuActiveStatus == 0) return;
    // if (isDisabledInmate) return;
    history.navigate("PublicUserList/Details", {
      state: { row: row, source: "InmateInfo", Inmate: Inmate },
    });
    dispatch(publicUserActions?.setPublicUserTab("publicuser-info-tab"));
  };

  const connectionColumn = [
    {
      name: "Public User",
      key: "PublicUserName",
      selector: (row) => row.PublicUserName,
      cell: (row) => (
        <div
          onClick={() => navigatePublicUser(row)}
          className={(PuAccessPermission[0]?.SubMenuActiveStatus !== 0 && user?.UserRoleID !== 13) ? "Common_Link_Style" : ""}
        >
          {row.PublicUserName}
        </div>
      ),

      sortable: true,
    },
    {
      width: "150px",
      name: "Relationship",
      key: "RelationShip",
      selector: (row) => row.RelationShip,
      cell: (row, i) => (
        <div>
          {!isEditing || index !== i ? (
            <>
              {row.RelationShip}{" "}
              {user?.UserRoleID !== 13 && (
                <i
                  style={{ color: "#cc5a5a", cursor: "pointer" }}
                  className="fa-solid fa-pen-to-square mx-2"
                  title="Edit"
                  onClick={() => handleEditClick(row, i)}
                ></i>
              )}
            </>
          ) : (
            isEditing &&
            index === i && (
              <div className="">
                <div className="form-floating">
                  <TextInput
                    name="AterModifiedRelationShip"
                    placeholder=""
                    maxLength={20}
                    value={editValue?.AterModifiedRelationShip}
                    handleChange={(e) => handleEditChange(e.target.value)}
                    errorMessage={relationShipErr}
                  />

                  {/* {relationShipErr && (
                    <span className="text-danger">{relationShipErr}</span> // Show validation message
                  )} */}
                </div>
                <i
                  className="fa-solid fa-circle-check cursor-pointer fs-3"
                  style={{ color: "#4a9a93" }}
                  title="Confirm"
                  onClick={() => handleConfirmClick(row)}
                ></i>
                <i
                  className="fa-solid fa-xmark cursor-pointer fs-3 ms-3"
                  style={{ color: "#cc5a5a" }}
                  title="Cancel"
                  onClick={handleCancelClick}
                ></i>
              </div>
            )
          )}
        </div>
      ),
      sortable: true,
    },
    {
      name: "Connection Status",
      key: "ConnectionStatus",
      selector: (row) => row.ConnectionStatus,
      sortable: true,
    },
    {
      name: "Request Sent On",
      key: "RequestSentDate",
      selector: (row) => formatDateTimeAMPM(row.RequestSentDate),
      sortable: true,
    },
    {
      name: "Credit Balance ($)",
      key: "CreditBalance",
      selector: (row) => row.CreditBalance?.toFixed(2),
      sortable: true,
    },
  ];

  // setting column

  // Table Columns
  const [expandChild, setExpandChild] = useState(false);

  useEffect(() => {
    const shouldExpand = data.some((row) => row.menuId === 3 && row.isChecked);
    setExpandChild(shouldExpand);
  }, [data]);

  const handleMenuClick = (row, checked) => {
    //  this is used for access the Table
    if (!checked) {
      updatedData = data[0].isChecked = true;
    }

    let menuId = row.menuId;

    if (row.menuId === 3) {
      setExpandChild(checked);
    }

    updatedData = data?.map((item, i) => {
      if (menuId === item.menuId) {
        return {
          ...item, // Spread the existing properties
          isChecked: checked, // Update the isChecked property
        };
      } else {
        return item; // Return the item as is for unmatched menuId
      }
    });

    // Check if all menu items (except SelectAll) are checked
    const allChecked = updatedData
      .filter((item) => item.menu !== "Select / UnSelect All")
      .every((item) => item.isChecked);

    // Update SelectAll checkbox based on allChecked status
    updatedData = updatedData.map((item) => {
      if (item.menu === "Select / UnSelect All") {
        return { ...item, isChecked: allChecked };
      }
      return item;
    });

    setData(updatedData);

    // Update the correct field based on menuId
    switch (row.menuId) {
      case 1:
        updatedInmateInfo.MessageAccess = checked ? 1 : 0;
        break;
      case 2:
        updatedInmateInfo.PhotoAccess = checked ? 1 : 0;
        break;
      case 3:
        updatedInmateInfo.FormReqAccess = checked ? 1 : 0;
        break;
      case 4:
        updatedInmateInfo.DocumentsAccess = checked ? 1 : 0;
        break;
      case 5:
        updatedInmateInfo.CommissaryAccess = checked ? 1 : 0;
        break;
      case 6:
        updatedInmateInfo.LawLibraryAccess = checked ? 1 : 0;
        break;
      case 9:
        updatedInmateInfo.InmateInvitePublicAccess = checked ? 1 : 0;
        break;
      case 11:
        updatedInmateInfo.PostalMailAccess = checked ? 1 : 0;
        break;
      case 33:
        updatedInmateInfo.AllowAccessAnyKiosks = checked ? 1 : 0;
        break;
      case 44:
        updatedInmateInfo.AllowKiosksAccess = checked ? 1 : 0;
        break;
      case 13:
        updatedInmateInfo.EcardAccess = checked ? 1 : 0;
        break;
      default:
        console.warn(`Unhandled menuId: ${row.menuId}`);
        break;
    }
    // Update the state with the new info
    setInmateInfo(updatedInmateInfo);
  };

  const handleLockAccess = (row, checked, i) => {
    const menuId = row.menuId;

    if (!checked && Object?.keys(errorMessage)?.length > 0) {
      delete errorMessage[`InmateLockAccess-${row?.menuId}-LockAccessFrom`];
      delete errorMessage[`InmateLockAccess-${row?.menuId}-LockAccessTo`];
    }
    // Update UI data
    updatedData = data?.map((item) =>
      menuId === item.menuId
        ? {
          ...item,
          lockAccess: checked,
        }
        : item
    );

    setData(updatedData);

    // Update InmateLockAccess
    let updatedInmateInfo = { ...inmateInfo };

    if (checked) {
      // Add the object if checkbox is checked
      const obj = {
        InmateLockAccessID: 0,
        InmateID: Inmate?.InmateID || inmate?.InmateID,
        InmateMenuID: menuId,
        LockAccessFrom: "",
        LockAccessTo: "",
        Status: 1,
      };

      updatedInmateInfo.InmateLockAccess = [
        ...inmateInfo.InmateLockAccess,
        obj,
      ];
    } else {
      // Remove the object if checkbox is unchecked
      updatedInmateInfo.InmateLockAccess = inmateInfo?.InmateLockAccess.filter(
        (access) => access.InmateMenuID !== menuId
      );
    }

    setInmateInfo(updatedInmateInfo);
  };

  // Date Change func for Setting Tab
  const handleInputChange = (name, date, index) => {
    // Clone the updatedData array to prevent direct mutation
    let newUpdatedData = [...updatedData];

    if (name === "from") {
      newUpdatedData[index].from = fDate(date);

      // Ensure 'to' date is not before 'from' date
      newUpdatedData[index].to =
        new Date(newUpdatedData[index].from) >
          new Date(newUpdatedData[index].to)
          ? newUpdatedData[index].from
          : newUpdatedData[index].to;

      // Update InmateLockAccess if menuId matches
      let newUpdatedInmateInfo =
        updatedInmateInfo?.InmateLockAccess &&
        updatedInmateInfo?.InmateLockAccess.map((item) => {
          if (item.InmateMenuID === newUpdatedData[index].menuId) {
            return {
              ...item,
              LockAccessFrom: fDate(date),
              LockAccessTo:
                new Date(newUpdatedData[index].from) >
                  new Date(newUpdatedData[index].to)
                  ? newUpdatedData[index].from
                  : newUpdatedData[index].to,
            };
          } else {
            return { ...item };
          }
        });

      setInmateInfo({
        ...updatedInmateInfo,
        InmateLockAccess: newUpdatedInmateInfo,
      });
    } else if (name === "to") {
      newUpdatedData[index].to = fDate(date);
      //
      let newUpdatedInmateInfo =
        updatedInmateInfo?.InmateLockAccess &&
        updatedInmateInfo?.InmateLockAccess.map((item) => {
          if (item.InmateMenuID === newUpdatedData[index].menuId) {
            return { ...item, LockAccessTo: fDate(date) };
          } else {
            return { ...item };
          }
        });
      setInmateInfo({
        ...updatedInmateInfo,
        InmateLockAccess: newUpdatedInmateInfo,
      });
    }
    // Update the state
    setData(newUpdatedData);
  };

  const handleSelectAll = (row, checked) => {
    let chk = updatedData.map((item, i) => {
      return {
        ...item,
        isChecked: checked,
      };
    });
    setData(chk);

    //this values is used to pass the param
    updatedInmateInfo.MessageAccess = checked ? 1 : 0;
    updatedInmateInfo.PhotoAccess = checked ? 1 : 0;
    updatedInmateInfo.EcardAccess = checked ? 1 : 0;
    updatedInmateInfo.FormReqAccess = checked ? 1 : 0;
    updatedInmateInfo.DocumentsAccess = checked ? 1 : 0;
    updatedInmateInfo.CommissaryAccess = checked ? 1 : 0;
    updatedInmateInfo.LawLibraryAccess = checked ? 1 : 0;
    updatedInmateInfo.InmateInvitePublicAccess = checked ? 1 : 0;
    updatedInmateInfo.PostalMailAccess = checked ? 1 : 0;
    updatedInmateInfo.AllowAccessAnyKiosks = checked ? 1 : 0;
    updatedInmateInfo.AllowKiosksAccess = checked ? 1 : 0;

    setInmateInfo(updatedInmateInfo);
  };

  const handleAccordian = (e, position) => {
    const { checked } = e?.target;
    switch (position) {
      case 1:
        setInfoCheckBox(checked);
        break;

      case 2:
        setSettingsCheckBox(checked);
        if (checked) {
          //Get the MenuAccess
          setIsLoading(true);
          dispatch(
            inmateAction.LoadInmateAccessMenuSettings({
              InmatesID: Inmate?.InmateID || inmate?.InmateID,
              FacilityID: Inmate?.facilityID || inmate?.facilityID || facilityCode,
            })
          );

          //Request Access Setting
          dispatch(
            inmateAction.LoadInmateRequestAccessSettings({
              InmatesID: Inmate?.InmateID || inmate?.InmateID,
              FacilityID: Inmate?.facilityID || inmate?.facilityID || facilityCode,
            })
          );
          setIsLoading(false);
        }
        break;

      case 3:
        setConnectionCheckBox(checked);
        if (checked) {
          setIsLoading(true);
          let param = {
            InmatesId: Inmate?.InmateID || inmate?.InmateID,
            ManagementUserID: user?.ManagementUserID,
            PageNo: 1,
            RowCountPerPage: 10,
            SortField: "",
          };
          setConnection(param);
          dispatch(inmateAction.LoadInmatePublicConnection(param)).then(() => setIsLoading(false));
        }
        break;

      case 4:
        setLoginInfoCheckBox(checked);
        if (checked) {
          setIsLoading(true);
          dispatch(inmateAction.LoadInmateLoginLogHistory({
            ...loginInfo, PodID: 0,
            InmateResidentId: Inmate?.InmateResidentID || Inmate?.InmateResidentId || inmate?.InmateResidentId || inmateInfoTabData[0]?.InmateResidentId
          })).then(() => setIsLoading(false));
        }
        break;

      default:
        break;
    }
  };

  let updatedInmateInfo = { ...inmateInfo };

  //Settings Tab
  const handleChangeText = (e) => {
    let { name, value } = e?.target;

    if (name === "Notes") {
      updatedInmateInfo.Notes = value.trimStart();
    } else if (name === "InmateInvitePublicCount") {
      // if (parseInt(value) > 100) return;
      // Remove decimal if present and ensure it only accepts whole numbers
      updatedInmateInfo.InmateInvitePublicCount =
        value && !isNaN(value) ? Math.floor(Number(value.trimStart())) : null;
    } else if (name === "InvestigatorEmail") {
      updatedInmateInfo.InvestigatorEmail = value.trim();
    }

    setInmateInfo(updatedInmateInfo);
  };

  const [errorLimit, setErrorLimit] = useState({});
  const MaxLimit = () => {
    setErrorLimit({});

    // Remove previous input errors
    document
      .querySelectorAll(".input-error")
      .forEach((el) => el.classList.remove("input-error"));

    // Run validation
    const { error } = limitSchema(updatedInmateInfo?.InmateInvitePublicCount);

    if (error?.details) {
      error.details.forEach((e) => {
        const { path } = e;
        const fieldName = path.join(".");

        // Update error messages
        setErrorLimit((prev) => ({
          ...prev,
          [fieldName]: e.message,
        }));

        // Find the input field and add error class
        const element = document.querySelector(`[name="${fieldName}"]`);
        if (element) {
          element.classList.add("input-error");
        }
      });

      return; // Stop execution if there's an error
    }
  };

  const handleSelectChange = (options, name) => {
    // updatedInmateInfo.InmateInvitePublicFrequencyType = options?.value;

    setInmateInfo({
      ...updatedInmateInfo,
      InmateInvitePublicFrequencyType: options?.value,
    });
  };

  // Connection Pagination


  const handleConnectionRowPerPage = (RowCount) => {
    setConnection((prev) => ({
      ...prev,
      PageNo: 1,
      RowCountPerPage: RowCount,
    }));
    dispatch(inmateAction.LoadInmatePublicConnection({ ...connection, PageNo: 1, RowCountPerPage: RowCount }));
  };

  const handleConnectionPageChange = (pageNo) => {
    if (isSorting) {
      isSorting = false;
      return;
    }
    setConnection((prev) => ({
      ...prev,
      PageNo: pageNo,
    }));
    dispatch(inmateAction.LoadInmatePublicConnection({ ...connection, PageNo: pageNo }));
  };

  //export Connection

  useEffect(() => {
    if (
      connectionDataFullList &&
      connectionDataFullList?.DataList?.length > 0
    ) {
      let title = "InmateConnections_List";
      let generateExcelColumns = [
        "Public User",
        "Relationship",
        "Connection Status",
        "Request Sent On",
        "Credit Balance($)",
      ];

      // Map the account manager list to match the Excel format
      let InmateConnection_List =
        connectionDataFullList?.DataList?.map((obj) => ({
          PublicUser: obj.PublicUserName,
          Relationship: obj.RelationShip,
          ConnectionStatus: obj.ConnectionStatus,
          RequestSentOn: formatDateTimeAMPM(obj.RequestSentDate),
          CreditBalance: obj.CreditBalance?.toFixed(2)?.toString().trimStart(),
        })) || [];

      try {
        // Generate the Excel file with the transformed data
        generateXlsx(InmateConnection_List, generateExcelColumns, title);

        // Clear excel data after the download
        dispatch(inmateAction.clearConnectionFullList());
      } catch (error) {
        // Handle any errors that occur during Excel generation
        console.error("Error generating Excel file:", error);
      }
    }
  }, [connectionDataFullList]);

  const handleConnectionExcel = () => {
    let param = {
      ...connection,
      PageNo: 1,
      RowCountPerPage: connectionDataList.TotalRecordCount,
      exportExcel: true,
    };
    dispatch(inmateAction.LoadInmatePublicConnection(param));
  };

  let isSorting = false;
  const handleSort = (column, sortDirection) => {
    if (!column?.key) return;
    isSorting = true;
    const search = { ...connection };
    const newSortOrder = search.SortField.includes(column.key)
      ? search.SortField.endsWith("asc")
        ? "desc"
        : "asc"
      : "asc";
    search.SortField = `${column.key} ${newSortOrder}`;
    setConnection(search);
    dispatch(
      inmateAction.LoadInmatePublicConnection({
        ...connection,
        SortField: `${column.key} ${newSortOrder}`,
      })
    );
  };

  let isLoginSorting = false;
  const handleLoginSort = (column, sortDirection) => {
    if (!column?.key) return;

    isLoginSorting = true;
    const search = {
      ...loginInfo,
      InmateResidentId:
        Inmate?.InmateResidentID ||
        Inmate?.InmateResidentId ||
        inmate?.InmateResidentId ||
        inmateInfoTabData[0]?.InmateResidentId
    };
    const newSortOrder = search.SortBy.includes(column.key)
      ? search.SortBy.endsWith("asc")
        ? "desc"
        : "asc"
      : "asc";
    search.SortBy = `${column.key} ${newSortOrder}`;
    setLoginInfo(search);
    dispatch(
      inmateAction.LoadInmateLoginLogHistory({
        ...loginInfo, PodID: 0,
        InmateResidentId:
          Inmate?.InmateResidentID ||
          Inmate?.InmateResidentId ||
          inmate?.InmateResidentId ||
          inmateInfoTabData[0]?.InmateResidentId,
        SortBy: `${column.key} ${newSortOrder}`,
      })
    );
  };

  //LoginHistory Column

  const loginColumn = [
    {
      name: "Date",
      key: "LogInDateTime",
      selector: (row) => row.LogInDateTime,
      sortable: true,
    },
    {
      name: "Inmate Id",
      key: "InmateResidentId",
      selector: (row) => row.InmateResidentId,
      sortable: true,
    },
    {
      name: "Pod Name",
      key: "PODName",
      selector: (row) => row.PODName,
      sortable: true,
    },
    {
      name: "Kiosks Code",
      key: "KiosksCode",
      selector: (row) => row.KiosksCode,
      sortable: true,
    },
    {
      name: "Entered Pin No",
      key: "EnterPinNo",
      selector: (row) => row.EnterPinNo,
      sortable: true,
    },
    {
      name: "Login Status",
      key: "LoginStatus",
      selector: (row) => row.LoginStatus,
      sortable: true,
    },
  ];


  const handleLoginInfoRowPerPage = (rowcount) => {
    setLoginInfo((prev) => ({
      ...prev,
      PageNo: 1,
      RowCountPerPage: rowcount,
    }));
    dispatch(inmateAction.LoadInmateLoginLogHistory({
      ...loginInfo, PodID: 0, PageNo: 1, RowCountPerPage: rowcount,
      InmateResidentId: Inmate?.InmateResidentID || Inmate?.InmateResidentId || inmate?.InmateResidentId || inmateInfoTabData[0]?.InmateResidentId
    }))
  };

  const handleLoginInfoPageChange = (pageno) => {
    if (isLoginSorting) {
      isLoginSorting = false;
      return;
    }
    setLoginInfo((prev) => ({
      ...prev,
      PageNo: pageno,
    }));
    dispatch(inmateAction.LoadInmateLoginLogHistory({
      ...loginInfo, PodID: 0, PageNo: pageno,
      InmateResidentId: Inmate?.InmateResidentID || Inmate?.InmateResidentId || inmate?.InmateResidentId || inmateInfoTabData[0]?.InmateResidentId
    }));
  };

  //LoginHistory Export

  useEffect(() => {
    if (loginLogFullHistory && loginLogFullHistory?.DataList?.length > 0) {
      let date = new Date();
      let formattedDate = `${date.getMonth() + 1
        }/${date.getDate()}/${date.getFullYear()}`;
      let title = `Log_${formattedDate}`;
      let generateExcelColumns = [
        "Date",
        "Inmate ID",
        "POD Name",
        "Kiosks Code",
        "Entered Pin No",
        "Login Status",
      ];

      // Map the account manager list to match the Excel format
      let InmateLogin_List =
        loginLogFullHistory?.DataList?.map((obj) => ({
          LogInDateTime: obj.LogInDateTime,
          InmateResidentId: obj.InmateResidentId,
          PODName: obj.PODName,
          KiosksCode: obj.KiosksCode,
          EnterPinNo: obj.EnterPinNo,
          LoginStatus: obj.LoginStatus,
        })) || [];

      try {
        // Generate the Excel file with the transformed data
        generateXlsx(InmateLogin_List, generateExcelColumns, title);

        // Clear excel data after the download
        dispatch(inmateAction.clearLoginlogFullHistory());
      } catch (error) {
        // Handle any errors that occur during Excel generation
        console.error("Error generating Excel file:", error);
      }
    }
  }, [loginLogFullHistory]);

  const handleLoginExport = () => {
    let updatedParam = {
      ...loginInfo,
      PageNo: 1,
      InmateResidentId:
        Inmate?.InmateResidentID ||
        Inmate?.InmateResidentId ||
        inmate?.InmateResidentId ||
        inmateInfoTabData[0]?.InmateResidentId,
      RowCountPerPage: loginLogHistory.TotalRecordCount,
      exportExcel: true,
      PodID: 0,
    };
    dispatch(inmateAction.LoadInmateLoginLogHistory(updatedParam));
  };

  //Submit
  const [errorMessage, setErrorMessage] = useState({});
  const handleSubmit = (e) => {
    e.preventDefault();

    setErrorMessage({});

    if (document?.getElementsByClassName("input-error").length > 0) {
      document
        .querySelectorAll(".input-error")
        .forEach((el) => el.classList.remove("input-error"));
    }

    let RForm = inmateInfo?.InmateRequestFormPermission?.filter(
      (item) => item.OverrideStatus === true
    ) // Filter only the items where OverrideStatus is true
      .map((item) => ({
        RFPermissionID: 0,
        RequestFormTypeID: item.RequestFormTypeID,
        FacilityRequestFormTitle: "",
        FrequencyCount: item.IFrequencyCount,
        FrequencyCalenderType: item.IFrequencyType,
        ActiveStatus: item.IActiveStatus,
      }));

    let param = {
      ...inmateInfo,
      InmateRequestFormPermission: RForm,
    };

    const { error } = validateInmateInfo(inmateInfo);

    // return;

    if (error?.details) {
      error?.details.map((e, i) => {
        const { path } = e;

        if (path[i] === "InmateRequestFormPermission" && e.message === "-5") {
          showToastNotification(
            "One of the PDS form is already activated. So, unable to activate the another PDS form.",
            "error"
          );
        }

        const className = path.join("-");
        setErrorMessage((prev) => ({
          ...prev,
          [className]: e?.message,
        }));
        // const escapedName = className.replace(/\./g, "\\.");
        // return;
        const element = document.querySelector(`[name=${className}]`);

        if (element) {
          element.classList.add("input-error", className);
        }
      });

      return;
    }

    if (Object.keys(errorLimit).length > 0) {
      Object.keys(errorLimit).forEach((fieldName) => {
        // Escape special characters for query selection
        const escapedName = fieldName.replace(/\./g, "\\.");

        // Find input field by name attribute and add the error class
        const element = document.querySelector(`[name="${escapedName}"]`);
        if (element) {
          element.classList.add("input-error");
        }
      });

      return; // Stop further execution if errors exist
    }

    // Insert Management User Activity Log
    dispatch(
      authActions?.ManagementUserActivityLog({
        ManagementUserID: user?.ManagementUserID,
        facilityID: facilityCode,
        ProcedureName: StoredProcedures?.InmateInfoUpdateDetails,
        UserAction: `Updated Inmate Info Details (InmateID -  ${Inmate?.InmateID})`,
      })
    );
    dispatch(inmateAction.InmateInfoUpdateDetails({ ...param, EcardAccess: param?.EcardAccess == null ? 0 : param?.EcardAccess }));
  };


  const handleBlurFrequencyType = () => {
    setErrorMessage({});

    const { error } = validateInmateInfo(inmateInfo);

    if (error?.details) {
      error?.details.map((e, i) => {
        const { path } = e;

        if (path[i] === "InmateRequestFormPermission" && e.message === "-5") {
          showToastNotification(
            "One of the PDS form is already activated. So, unable to activate the another PDS form.",
            "error"
          );
        }

        setErrorMessage((prev) => ({
          ...prev,
          [path.join(".")]: e?.message,
        }));

        const className = path.join(".");
        const escapedName = className.replace(/\./g, "\\.");
        const element = document.querySelector(`[name=${escapedName}]`);

        if (element) {
          element.classList.add("input-error", className);
        }
      });

      return;
    }

    if (Object.keys(errorLimit).length > 0) {
      Object.keys(errorLimit).forEach((fieldName) => {
        // Escape special characters for query selection
        const escapedName = fieldName.replace(/\./g, "\\.");

        // Find input field by name attribute and add the error class
        const element = document.querySelector(`[name="${escapedName}"]`);
        if (element) {
          element.classList.add("input-error");
        }
      });

      return; // Stop further execution if errors exist
    }
  };

  const [reset, setReset] = useState(false);

  const handleReset = () => {
    setReset(true);

    //Clear the LoginInfo Grid Page No & RowCount
    setLoginInfo({
      ...loginInfo,
      PageNo: 1,
      RowCountPerPage: 10,
      SortBy: "",
    });
    dispatch(
      inmateAction.LoadInmateLoginLogHistory({
        ...loginInfo,
        PodID: 0,
        PageNo: 1,
        RowCountPerPage: 10,
        SortBy: "",
      })
    );

    //Clear the Connection Grid Page No & RowCount
    setConnection({
      ...connection,
      PageNo: 1,
      RowCountPerPage: 10,
      SortField: "",
    });

    dispatch(
      inmateAction.LoadInmatePublicConnection({
        ...connection,
        PageNo: 1,
        RowCountPerPage: 10,
        SortField: "",
      })
    );

    // Clear error messages
    setErrorMessage({});
    setErrorLimit({});
    // Remove input-error class from all input fields
    const errorElements = document.querySelectorAll(".input-error");
    errorElements.forEach((element) => {
      element.classList.remove("input-error");
    });
    dispatch(
      inmateAction.LoadInmateAccessMenuSettings({
        InmatesID: Inmate?.InmateID || inmate?.InmateID,
        FacilityID: Inmate?.facilityID || inmate?.facilityID || facilityCode,
      })
    );

    //Request Access Setting
    dispatch(
      inmateAction.LoadInmateRequestAccessSettings({
        InmatesID: Inmate?.InmateID || inmate?.InmateID,
        FacilityID: Inmate?.facilityID || inmate?.facilityID || facilityCode,
      })
    );

    //Get the Tab List
    dispatch(inmateAction.InmatesInfoTab(Inmate?.InmateID || inmate?.InmateID));

    const updatedArr = data.map((obj) => ({
      ...obj,
      from: "",
      to: "",
      lockAccess: false,
    }));
    setData(updatedArr);
  };

  const handleUpdateSecurity = (e) => {
    e.preventDefault();
    dispatch(inmateAction.InmateSecurityQuestionInsertUpdate({ ...paramSQ, FacilityID: Inmate?.facilityID || inmate?.facilityID || facilityCode }));
  };

  const handleCancelSequrity = () => {
    setSQindex(null);
    setEditSQ(false);
    setSquestion(securityQuestion);
  };

  const handleEditSecurityQuestion = (index) => {
    dispatch(
      inmateAction.GetLoadInmateSecurityQuestionSet({
        InmatesID: Inmate?.InmateID || inmate?.InmateID,
        FacilityID: Inmate?.facilityID || inmate?.facilityID || facilityCode,
      })
    );
    setEditSQ(true); // Set edit mode to true
    setSQindex(index); // Set the current question index

    let updatedSQ = {
      InmatesId: Inmate?.InmateID || inmate?.InmateID,
      FacilityID: Inmate?.facilityID || inmate?.facilityID || facilityCode,
      SQuestionID: securityQuestion[index].QuestionID,
      SQuestionSetID: securityQuestion[index].QuestionSetID,
      Action: 1,
      SQAnswer: securityQuestion[index].SQAnswer,
      SubmittedBy: user?.ManagementUserID,
      SubmitterID: user?.ManagementUserID,
    };

    setParamSQ(updatedSQ);
  };

  const handleEditSQChange = (value, index) => {
    // Create a shallow copy of the Squestion array
    let updatedSQ = [...Squestion];

    // Create a new object for the specific index to avoid mutating the original object
    updatedSQ[index] = { ...updatedSQ[index], SQAnswer: value };

    let param = {
      InmatesId: updatedSQ[index].InmateID,
      FacilityID: updatedSQ[index].facilityID,
      SQuestionID: updatedSQ[index].QuestionID,
      SQuestionSetID: updatedSQ[index].QuestionSetID,
      Action: 1,
      SQAnswer: updatedSQ[index].SQAnswer,
      SubmittedBy: user?.ManagementUserID,
      SubmitterID: user?.ManagementUserID,
    };

    setParamSQ(param);
    // Update the state with the modified array
    setSquestion(updatedSQ);
  };

  const handleOverrideStatus = (checked, i) => {
    updatedInmateInfo.InmateRequestFormPermission[i].IFrequencyCount =
      updatedInmateInfo.InmateRequestFormPermission[i].IFrequencyCount
        ? updatedInmateInfo.InmateRequestFormPermission[i].IFrequencyCount
        : -1;
    updatedInmateInfo.InmateRequestFormPermission[i].IFrequencyType =
      updatedInmateInfo.InmateRequestFormPermission[i].IFrequencyType
        ? updatedInmateInfo.InmateRequestFormPermission[i].IFrequencyType
        : -1;
    updatedInmateInfo.InmateRequestFormPermission[i].OverrideStatus = checked;
    setInmateInfo(updatedInmateInfo);
  };

  const handleSelectRForm = (selectedOption, name, index) => {
    // Clone the state to avoid direct mutation
    setInmateInfo((prevInfo) => {
      let updatedPermissions = [...prevInfo.InmateRequestFormPermission];

      updatedPermissions[index] = {
        ...updatedPermissions[index],
        [name]: selectedOption?.value,
        ...(selectedOption?.value === -1
          ? name === "IFrequencyCount"
            ? { IFrequencyType: -1 }
            : { IFrequencyCount: -1 }
          : name === "IFrequencyType" &&
            selectedOption?.value > 0 &&
            parseInt(updatedPermissions[index].IFrequencyCount) === -1
            ? { IFrequencyCount: 1 }
            : name === "IFrequencyCount" &&
              selectedOption?.value >= 0 &&
              parseInt(updatedPermissions[index].IFrequencyType) <= 0
              ? { IFrequencyType: 1 }
              : {}),
      };

      return {
        ...prevInfo,
        InmateRequestFormPermission: updatedPermissions,
      };
    });
  };

  const handleStatusChange = (value, i) => {
    updatedInmateInfo.InmateRequestFormPermission[i].IActiveStatus =
      parseInt(value);
    setInmateInfo(updatedInmateInfo);
  };

  const handleResetSecurity = () => {
    Popup({
      title: "Message",
      text: `Are you sure you want to clear the security question set?`,
      icon: "info",
      confirmButtonText: "YES",
      cancelButtonText: "NO",
      // onConfirm: () => dispatch(documentsActions.DeleteDocument(payload)),
      onConfirm: () => {
        dispatch(
          inmateAction.GetInmateResetSecurityQuestion({
            inmateId: Inmate?.InmateID || inmate?.InmateID,
            FacilityID:
              Inmate?.facilityID || inmate?.facilityID || facilityCode,
          })
        );
      },
    });
  };

  useEffect(() => {
    if (newmergeInmate.length > 0) {
      setMergeInmateFrom((prev) => ({
        ...prev,
        newInmateResidentId:
          newmergeInmate && newmergeInmate[0]?.InmateResidentId,
      }));
    }
  }, [newmergeInmate]);

  const [mergeInmateFrom, setMergeInmateFrom] = useState({
    oldInmateId: Inmate?.InmateID || inmate?.InmateID,
    oldInmateResidentId:
      Inmate?.InmateResidentID ||
      Inmate?.InmateResidentId ||
      inmate?.InmateResidentId,
    newInmateId: 0,
    newInmateResidentId:
      (newmergeInmate && newmergeInmate[0]?.InmateResidentId) || 0,
    facilityID: Inmate?.facilityID || inmate?.facilityID, // Inmate?.InmateID,
  });

  const handlemergeChange = (selectedOption) => {
    if (selectedOption?.value) {
      setMergeError({});

      if (document?.getElementsByClassName("input-error").length > 0) {
        document
          .querySelectorAll(".input-error")
          .forEach((el) => el.classList.remove("input-error"));
      }
    }

    setMergeInmateFrom((prev) => ({
      ...prev,
      newInmateId: selectedOption?.value,
    }));
  };

  const [mergeError, setMergeError] = useState();

  const handleMergeSubmit = (e) => {
    e.preventDefault();
    setMergeError({});

    if (document?.getElementsByClassName("input-error").length > 0) {
      document
        .querySelectorAll(".input-error")
        .forEach((el) => el.classList.remove("input-error"));
    }

    const { error } = inmateMergeSchema(mergeInmateFrom);

    if (error?.details) {
      error?.details.map((e) => {
        const { path } = e;
        setMergeError((prev) => ({
          ...prev,
          [path.join(".")]: e?.message,
        }));

        const className = path.join(".");
        const escapedName = className.replace(/\./g, "\\.");
        const element = document.querySelector(`[name=${escapedName}]`);

        if (element) {
          element.classList.add("input-error", className);
        }
      });

      return;
    }

    dispatch(inmateAction.MergeInmateDetails(mergeInmateFrom));
  };


  const handleDateEnterKey = (event, name, index) => {
    // if (event.key === "Enter" && PostalMailSearch[name] === "") {
    if (event.key === "Enter") {
      const currentDate = new Date();

      // Set today's date using the same logic as your handleDateChange
      // handleDateChange(name, currentDate);
      handleInputChange(name, currentDate, index);
    }

    const regex = /^[0-9/]$/; // Allow numbers and "/"

    if (
      !regex.test(event.key) &&
      event.key !== "Backspace" &&
      event.key !== "Delete" &&
      !(event.ctrlKey && event.key === "v")
    ) {
      event.preventDefault();
    }

    // Auto-insert '/' when typing
    const input = event.target.value;

    if (event.key !== "Backspace" && event.key !== "Delete") {
      if (input?.length === 2 || input?.length === 5) {
        event.target.value = input + "/";
      }
    }
  };


  //new
  const handleDateBlur = (e, fieldName, index) => {
    const { value } = e.target;
    const dateValue = [...data];
    const inputDate = new Date(value);

    if (isNaN(inputDate)) {
      //if month value is more than 13
      dateValue[index][fieldName] = "";
      setData(dateValue);
      return;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const minDate = MinDate();
    minDate.setHours(0, 0, 0, 0);

    let isFromValid = true;
    let isToValid = true;

    if (fieldName === "from") {
      const toDate = new Date(data[index]["to"]);

      if (inputDate < today) {
        isFromValid = false;
      }

      if (data[index]["to"] && inputDate > toDate) {
        isFromValid = false;
      }

      dateValue[index]["from"] = isFromValid ? value : "";
    }

    if (fieldName === "to") {
      const fromDate = new Date(data[index]["from"]);

      if (data[index]["from"] && inputDate < fromDate) {
        isToValid = false;
      }

      if (inputDate < minDate) {
        isToValid = false;
      }

      dateValue[index]["to"] = isToValid ? value : "";
    }

    setData(dateValue);
  };

  const handleBack = () => {
    if (source === "photos") {
      history.navigate("/Admin/PhotoList");
      return;
    }
    if (source === "InmateMessage") {
      dispatch(inmateAction.setInmateCurrentTab("inmate-message-tab"));
    } else if (source === "InmatePhotos") {
      dispatch(inmateAction.setInmateCurrentTab("inmate-photos-tab"));
    }
    else if (source === "InmateEcard") {
      dispatch(inmateAction.setInmateCurrentTab("inmate-ecard-tab"));
    }
    else if (source === "RegisteredUser") {
      history.navigate("/Admin/RegisteredUserList/Edit", {
        state: {
          userId: publicUserId,
          ActiveStatus: ActiveStatus,
        },
      });
    } else if (source === "connectionRequest") {
      history.navigate("/Admin/ConnectionRequestList");
    } else if (source === "publicUserMesage") {
      history.navigate("/Admin/PublicUserList/Details", {
        state: {
          row: row,
        },
      });
      dispatch(publicUserActions?.setPublicUserTab("publicuser-message-tab"));
    }
    else if (source === "publicUserPhoto") {
      history.navigate("/Admin/PublicUserList/Details", {
        state: {
          row: row,
        },
      });
      dispatch(publicUserActions?.setPublicUserTab("publicuser-photos-tab"));
    }
    else if (source === "publicUserEcard") {
      history.navigate("/Admin/PublicUserList/Details", {
        state: {
          row: row,
        },
      });
      dispatch(publicUserActions?.setPublicUserTab("publicuser-ecard-tab"));
    } else if (source === "message") {
      history.navigate("/Admin/MessageList");
    } else if (source === "publicUserConnection") {
      history.navigate("/Admin/PublicUserList/Details", {
        state: {
          row: row,
        },
      });
      dispatch(publicUserActions?.setPublicUserTab("publicuser-info-tab"));
    } else if (source === "logreport-inmate-access") {
      dispatch(
        publicUserActions?.setLogReportsCurrrentTab("logreport-inmate-access")
      );
      history.navigate("/Admin/LogReports");
    } else if (source === "IpActivity") {
      history.navigate("/Admin/IPActivityList/Details", {
        state: {
          ipAddressState: location?.state?.ipAddressState,
          FacilityID: location?.state?.FacilityId,
        },
      });
    } else if (source === "ecard") {
      history.navigate("/Admin/E-Cards/Sent");
    } else {
      Swal.close();
      dispatch(inmateAction.clearInmate());
      dispatch(inmateAction.setInmateCurrentTab("inmate-info-tab"));
      history.navigate("/Admin/InmateList");
    }
  };

  if (loading || publicuserLoading || masterLoading || authLoading || isloading) {
    return <CustomLoader />;
  }
  return (
    <div>
      <div className="p-2 ">
        <div className="d-flex flex-wrap justify-content-between align-items-center flex-wrap ">
          <h4 className=" inner-subheader-bg text-color">
            <i class="fa fa-info-circle me-2"></i>Info
          </h4>
          <Button
            label="Back"
            type="button"
            status="primary"
            icon={"fa-solid fa-angle-left"}
            onClick={() => handleBack()}
          />
        </div>
      </div>
      <div className="accordion" id="accordion-info">
        <div className="accordion-item border-0">
          <div className="card mb-3">
            <div className="accordion-header" id="headingInfo">
              <button
                className={`accordion-button 
                ${infoCheckBox ? "" : "collapsed"} 
              text-black fs-4 fw-bold px-3 py-2 pointer-cursor border-grey w-100`}
                type="button"
                aria-expanded={true}
                onClick={() =>
                  handleAccordian({ target: { checked: !infoCheckBox } }, 1)
                }
              >
                Information
                {/* <span className="d-flex flex-wrap justify-content-between align-items-center w-100">
                  <CheckBoxInput
                    label="Information"
                    name="infoCheckBox"
                    id="infoCheckBox"
                    handleClick={(e) => handleAccordian(e, 1)}
                    value={infoCheckBox}
                    checked={infoCheckBox}
                  />
                </span> */}
              </button>
            </div>
            <div
              id="info-accordion"
              className={`accordion-collapse ${infoCheckBox ? "show" : "collapse"
                }`}
              aria-labelledby="headingInfo"
            >
              <div className="accordion-body fs-5 p-2 m-2">
                <h4 className="inner-header-bg text-color">
                  <i className="fa-solid fa-user me-2"></i>Inmate Information{" "}
                </h4>
                <div className="">
                  <div className="row">
                    {[
                      {
                        label: "ID",
                        value: inmateInfoTabData[0]?.InmateResidentId,
                      },
                      {
                        label: "First Name",
                        value: inmateInfoTabData[0]?.FirstName,
                      },
                      {
                        label: "Middle Name",
                        value: inmateInfoTabData[0]?.MiddleName,
                      },
                      {
                        label: "Last Name",
                        value: inmateInfoTabData[0]?.LastName,
                      },
                      { label: "Pin No", value: inmateInfoTabData[0]?.PinNo },
                      {
                        label: "Date of Birth",
                        value: inmateInfoTabData[0]?.DOB,
                      },
                      { label: "Age", value: inmateInfoTabData[0]?.Age },
                      { label: "Gender", value: inmateInfoTabData[0]?.Gender },
                      { label: "POD", value: inmateInfoTabData[0]?.PodCode },
                      {
                        label: "Status",
                        value: inmateInfoTabData[0]?.InmateStatus,
                      },
                    ].map((item, index) => (
                      <div
                        key={index}
                        className="col-sm-6 col-md-6 col-lg-6 col-xl-4"
                      >
                        <div className="user-information d-flex  align-items-center">
                          <div className="fs-5 p-2  value-info">
                            {item.label}
                          </div>
                          <div className="p-2">:</div>
                          <div className="fs-5 p-2 text-start fw-bold value-text">
                            {item.value || "-"}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* <Table columns={columns} data={infoData} /> */}
                </div>
                <div>
                  {inmateInfoTabData[0]?.InmateStatus === "Released" && (
                    <>
                      {" "}
                      <div className="d-flex flex-wrap">
                        <h3 className="form_title_uppercase text-color mt-2 ms-2">
                          Merge Process
                        </h3>
                      </div>
                      <div className="d-flex flex-wrap justify-content-center align-items-center">
                        <div className="p-3 w-50">
                          <div className="row align-items-center">
                            {/* Select Input (Inmate Dropdown) */}
                            <div className="col-md-9">
                              <div className="form-floating">
                                <SelectInput
                                  name="newInmateId"
                                  options={mergeInmate}
                                  value={mergeInmateFrom?.newInmateId}
                                  isDisabled={
                                    mergeRes !== null && mergeRes !== undefined
                                      ? mergeRes === 1
                                        ? true
                                        : false
                                      : inmateInfoTabData[0]
                                        ?.IsInmateMergeTo === false
                                        ? false
                                        : true
                                  }
                                  isLoading={false}
                                  isClearable={false}
                                  label="Inmate"
                                  placeholder="-- Select --"
                                  handleChange={(selectedOption) =>
                                    handlemergeChange(selectedOption)
                                  }
                                  errorMessage={mergeError}
                                />
                              </div>
                            </div>

                            {/* Merge Button */}
                            <div className="col-md-3 text-end mt-3">
                              {mergeInmate && mergeInmate.length > 0 && (
                                <Button
                                  variant="primary"
                                  label="MERGE"
                                  type="button"
                                  status="primary"
                                  disabled={
                                    mergeRes !== null && mergeRes !== undefined
                                      ? mergeRes === 1
                                        ? true
                                        : false
                                      : inmateInfoTabData[0]
                                        ?.IsInmateMergeTo === false
                                        ? false
                                        : true
                                  }
                                  onClick={handleMergeSubmit}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="accordion" id="accordion-settings">
        <div className="accordion-item border-0">
          <div className="card mb-3">
            <div className="accordion-header" id="headingSettings">
              <button
                className={`accordion-button  
                ${settingsCheckBox ? "" : "collapsed"} 
              text-black fs-4 fw-bold px-3 py-2  pointer-cursor  border-grey w-100`}
                type="button"
                aria-expanded={true}
                onClick={() =>
                  handleAccordian({ target: { checked: !settingsCheckBox } }, 2)
                }
              >
                Settings
                {/* <span className="d-flex flex-wrap justify-content-between align-items-center w-100">
                  <CheckBoxInput
                    label="Settings"
                    name="settingsCheckBox"
                    id="settingsCheckBox"
                    handleClick={(e) => handleAccordian(e, 2)}
                    value={settingsCheckBox}
                    checked={settingsCheckBox}
                  />
                </span> */}
              </button>
            </div>
            <div
              id="settings-accordion"
              className={`accordion-collapse ${settingsCheckBox ? "show" : "collapse"
                }`}
              aria-labelledby="headingSettings"
            >
              <div className="accordion-body fs-5 p-2 m-2">
                <div>
                  {/* Parent Table */}

                  <h4 className="inner-header-bg text-color">
                    <i className="fa-solid fa-gear me-2"></i>Settings{" "}
                  </h4>
                  <p className="fst-italic font-bold">
                    Note : Based on POD Setting configure below setting
                  </p>
                  <div className="table-responsive settings-table">
                    <table className="table table-bordered table-hover w-100">
                      <thead
                        className="text-white text-center"
                        style={{ backgroundColor: "#cc595a" }}
                      >
                        <tr>
                          <th rowSpan="2" className="text-center text-white">
                            Accessible Menus
                          </th>
                          <th rowSpan="2" className="text-center text-white">
                            Lock Access
                          </th>
                          <th colSpan="2" className="text-center text-white">
                            Restrict
                          </th>
                        </tr>
                        <tr>
                          <th className="text-center text-white">FROM</th>
                          <th className="text-center text-white ">TO</th>
                        </tr>
                      </thead>

                      <tbody>
                        {data?.map((row, index) =>
                          (row.showField || row.keyAccess == "SelectAll") ? (
                            <React.Fragment key={index}>

                              <tr>
                                {/* Checkbox for Menu Selection */}
                                <td>
                                  <CheckBoxInput
                                    label={row.menu}
                                    name={`MenuAccess${row.menuId}`}
                                    id={`MenuAccess${row.menuId}`}
                                    checked={row.isChecked}
                                    handleClick={(e) =>
                                      row.menu === "Select / UnSelect All"
                                        ? handleSelectAll(row, e.target.checked)
                                        : handleMenuClick(row, e.target.checked)
                                    }
                                    disabled={isDisabledInmate}
                                    title={row.title}
                                  />
                                </td>

                                {/* Lock Access Checkbox */}
                                <td
                                  className="text-center"
                                  style={{ width: "40px" }}
                                >
                                  {row.menuId !== 0 &&
                                    row.menuId !== 33 &&
                                    row.menuId !== 44 && (
                                      <CheckBoxInput
                                        name={`lockAccess${row.menuId}`}
                                        id={`lockAccess${row.menuId}`}
                                        checked={row.lockAccess}
                                        handleClick={(e) =>
                                          handleLockAccess(
                                            row,
                                            e.target.checked,
                                            index
                                          )
                                        }
                                        disabled={
                                          !row.isChecked ||
                                          isDisabledInmate
                                        }
                                      />
                                    )}
                                </td>

                                {/* Date Input for Restrictions */}
                                <td className="text-center">
                                  {row.menuId !== 0 &&
                                    row.menuId !== 33 &&
                                    row.menuId !== 44 && (
                                      <>
                                        {/* <DateInput
                                        name="LockAccessFrom"
                                        value={row?.from}
                                        minDate={new Date()}
                                        handleChange={(date) =>
                                          handleInputChange("from", date, index)
                                        }
                                        placeholderText="MM/DD/YYYY"
                                        errorMessage={{
                                          LockAccessFrom:
                                            errorMessage?.[
                                              `InmateLockAccess.${row.menuId}.LockAccessFrom`
                                            ] || "",
                                        }}
                                        disabled={
                                          !row.isChecked ||
                                          !row.lockAccess ||
                                          isDisabledInmate
                                        }
                                        isClearable={row?.from ? true : false}
                                        handleKeyDown={(e) =>
                                          handleDateEnterKey(e, "from", index)
                                        }
                                      /> */}

                                        <DateInput
                                          // name="LockAccessFrom"
                                          name={`InmateLockAccess-${row.menuId}-LockAccessFrom`}
                                          value={row?.from}
                                          handleChange={(date) =>
                                            handleInputChange("from", date, index)
                                          }
                                          // errorMessage={{
                                          //   LockAccessFrom:
                                          //     errorMessage?.[
                                          //       `InmateLockAccess-${row.menuId}-LockAccessFrom`
                                          //     ] || "",
                                          // }}
                                          errorMessage={errorMessage}
                                          placeholderText="MM/DD/YYYY"
                                          yearDropDown
                                          minDate={new Date()}
                                          disabled={
                                            !row.isChecked ||
                                            !row.lockAccess || isDisabledInmate
                                          }
                                          isClearable={row?.from ? true : false}
                                          handleKeyDown={(e) =>
                                            handleDateEnterKey(e, "from", index)
                                          }
                                          // maxDate={
                                          //   messageSearchData?.MessageSendEndDate
                                          //     ? messageSearchData?.MessageSendEndDate
                                          //     : new Date()
                                          // }
                                          handleBlur={(e) =>
                                            handleDateBlur(e, "from", index)
                                          }
                                        // errorMessage={errorMessage}
                                        />
                                      </>
                                    )}
                                </td>

                                <td className="text-center">
                                  {row.menuId !== 0 &&
                                    row.menuId !== 33 &&
                                    row.menuId !== 44 && (
                                      <DateInput
                                        // name="LockAccessTo"
                                        name={`InmateLockAccess-${row.menuId}-LockAccessTo`}
                                        value={row?.to}
                                        minDate={row?.from}
                                        handleChange={(date) =>
                                          handleInputChange("to", date, index)
                                        }
                                        placeholderText="MM/DD/YYYY"
                                        // errorMessage={{
                                        //   LockAccessTo:
                                        //     errorMessage?.[
                                        //       `InmateLockAccess-${row.menuId}-LockAccessTo`
                                        //     ] || "",
                                        // }}
                                        errorMessage={errorMessage}
                                        disabled={
                                          !row.isChecked ||
                                          !row.lockAccess ||
                                          isDisabledInmate
                                        }
                                        isClearable={row?.to ? true : false}
                                        handleKeyDown={(e) =>
                                          handleDateEnterKey(e, "to", index)
                                        }
                                        handleBlur={(e) =>
                                          handleDateBlur(e, "to", index)
                                        }
                                      // errorMessage={errorMessage}
                                      />
                                    )}
                                </td>
                              </tr>

                              {/* Child Table - GLOBAL SETUP */}
                              {expandChild && row.menuId === 3 && (
                                <tr>
                                  <td colSpan="4">
                                    <div className="mt-3 p-3 w-100">
                                      <h4 className="inner-subheader-bg text-color">
                                        <i class="fa-solid fa-globe me-2"></i>
                                        Global Setup
                                      </h4>
                                      <div className="table-responsive">
                                        <table className="table table-bordered table-hover w-100">
                                          <thead
                                            className="text-white text-center"
                                            style={{ backgroundColor: "#cc595a" }}
                                          >
                                            <tr>
                                              <th
                                                rowSpan="2"
                                                className="align-middle text-white"
                                              >
                                                Form Title
                                              </th>
                                              <th
                                                rowSpan="2"
                                                className="align-middle text-white"
                                              >
                                                Global Setup
                                              </th>
                                              <th
                                                rowSpan="2"
                                                className="align-middle text-white"
                                              >
                                                Override
                                              </th>
                                              <th
                                                colSpan="2"
                                                className="text-center text-white"
                                              >
                                                Individual Setup
                                              </th>
                                              <th
                                                rowSpan="2"
                                                className="align-middle text-white"
                                              >
                                                Status
                                              </th>
                                            </tr>
                                            <tr>
                                              <th
                                                className="text-center text-white"
                                                style={{ width: " 100px" }}
                                              >
                                                Count
                                              </th>
                                              <th
                                                className="text-center text-white"
                                                style={{ width: " 150px" }}
                                              >
                                                Frequency
                                              </th>
                                            </tr>
                                          </thead>

                                          <tbody>
                                            {inmateInfo?.InmateRequestFormPermission?.map(
                                              (form, index) => (
                                                <tr
                                                  key={index}
                                                  className="align-middle text-center"
                                                >
                                                  {/* Form Title */}
                                                  <td className="text-start">
                                                    {
                                                      form.FacilityRequestFormTitle
                                                    }
                                                  </td>

                                                  {/* Global Setup */}
                                                  <td>
                                                    {form.FrequencyCount === -1
                                                      ? "NA"
                                                      : `${form.FrequencyCount
                                                      } / ${form.FrequencyCalenderType ===
                                                        1
                                                        ? "Day"
                                                        : form.FrequencyCalenderType ===
                                                          2
                                                          ? "Week"
                                                          : form.FrequencyCalenderType ===
                                                            3
                                                            ? "Month"
                                                            : "NA"
                                                      }`}
                                                  </td>

                                                  {/* Override Checkbox */}
                                                  <td>
                                                    <CheckBoxInput
                                                      // label="OverrideStatus"
                                                      name="OverrideStatus"
                                                      id="OverrideStatus"
                                                      handleClick={(e) =>
                                                        handleOverrideStatus(
                                                          e.target.checked,
                                                          index
                                                        )
                                                      }
                                                      disabled={isDisabledInmate}
                                                      value={form.OverrideStatus}
                                                      checked={
                                                        form.OverrideStatus
                                                      }
                                                    />
                                                  </td>

                                                  {/* Individual Setup Count Dropdown */}
                                                  <td>
                                                    {form.RequestFormTypeID ===
                                                      1 ||
                                                      form.RequestFormTypeID ===
                                                      59 ||
                                                      form.RequestFormTypeID ===
                                                      63 ||
                                                      form.RequestFormTypeID ===
                                                      62 ? (
                                                      <label>NA</label>
                                                    ) : (
                                                      <SelectInput
                                                        name="IFrequencyCount"
                                                        id="IFrequencyCount"
                                                        // label="Select Count"
                                                        // options={
                                                        //   facilityFrequencyCount
                                                        // }
                                                        options={
                                                          staticRequestFormTypeID.includes(
                                                            form.RequestFormTypeID
                                                          )
                                                            ? facilityFrequencyCount
                                                            : [
                                                              {
                                                                label: "NA",
                                                                value: -1,
                                                              },
                                                              {
                                                                label: "0",
                                                                value: 0,
                                                              },
                                                              ...facilityFrequencyCount.slice(
                                                                1
                                                              ),
                                                            ]
                                                        }
                                                        handleChange={(
                                                          selectedOption
                                                        ) =>
                                                          handleSelectRForm(
                                                            selectedOption,
                                                            "IFrequencyCount",
                                                            index
                                                          )
                                                        }
                                                        value={parseInt(
                                                          form?.IFrequencyCount
                                                        )}
                                                        placeholder="NA"
                                                        required={true}
                                                        maxLength={50}
                                                        isClearable={false}
                                                        isDisabled={
                                                          !form.OverrideStatus ||
                                                          form.OverrideStatus ===
                                                          undefined || isDisabledInmate
                                                        }
                                                      // errorMessage={errorMessage}
                                                      />
                                                    )}
                                                  </td>

                                                  {/* Individual Setup Frequency Dropdown */}
                                                  <td>
                                                    {form.RequestFormTypeID ===
                                                      1 ||
                                                      form.RequestFormTypeID ===
                                                      59 ||
                                                      form.RequestFormTypeID ===
                                                      63 ||
                                                      form.RequestFormTypeID ===
                                                      62 ? (
                                                      <label>NA</label>
                                                    ) : (
                                                      <SelectInput
                                                        name="IFrequencyType"
                                                        id="IFrequencyType"
                                                        // label="Select Count"
                                                        options={requestFrequency}
                                                        handleChange={(
                                                          selectedOption
                                                        ) =>
                                                          handleSelectRForm(
                                                            selectedOption,
                                                            "IFrequencyType",
                                                            index
                                                          )
                                                        }
                                                        value={
                                                          form?.IFrequencyType
                                                        }
                                                        placeholder="NA"
                                                        required={true}
                                                        maxLength={50}
                                                        isClearable={false}
                                                        isDisabled={
                                                          !form.OverrideStatus ||
                                                          form.OverrideStatus ===
                                                          undefined || isDisabledInmate
                                                        }
                                                      // errorMessage={errorMessage}
                                                      />
                                                    )}
                                                  </td>

                                                  {/* Status Radio Buttons */}
                                                  <td>
                                                    <RadioInput
                                                      name={`Status${index}`}
                                                      id={`Status${index}`}
                                                      options={requestStatus}
                                                      // label="Status"
                                                      selectedValue={
                                                        form.IActiveStatus
                                                      }
                                                      handleChange={(e) =>
                                                        handleStatusChange(
                                                          e.target.value,
                                                          index
                                                        )
                                                      }
                                                      disabled={
                                                        !form.OverrideStatus || isDisabledInmate ||
                                                        form.OverrideStatus ===
                                                        undefined
                                                      }
                                                      errorMessage={{
                                                        [`Status${index}`]:
                                                          errorMessage?.[`InmateRequestFormPermission-${index}-IActiveStatus`] || "",
                                                      }}
                                                    />
                                                  </td>
                                                </tr>
                                              )
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              )}
                            </React.Fragment>
                          ) : null
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <>
                {inmateInfoTabData[0]?.IsInmateSQ === 1 && (
                  <div className="accordion-body fs-5 p-2 m-2">
                    <div className="card p-4 border border-dark-grey mt-3 me-3 ms-0 w-100 ">
                      <div className="d-flex flex-wrap justify-content-between align-items-center mb-3">
                        <h2 className="form_title_uppercase text-color mb-0">
                          Security Setup
                        </h2>
                        {Squestion?.length > 0 && (
                          <Button
                            variant="primary"
                            className="me-2"
                            label=" RESET SECURITY QUESTION SET"
                            type="submit"
                            icon={"fa-solid fa-rotate-right"}
                            status="primary"
                            disabled={false}
                            isdisabled={[1, 2, 6, 12]?.includes(user?.UserRoleID) ? false : true}
                            onClick={handleResetSecurity}
                          />
                        )}
                      </div>
                      <div className="d-flex flex-wrap justify-content-center">
                        {securityQuestion?.length === 0 && (
                          <h5 style={{ color: "#c8605e" }}>
                            Security questions are not updated yet by Inmate.
                          </h5>
                        )}
                      </div>

                      {Squestion?.map((question, index) => (
                        <div
                          key={index}
                          className="d-flex flex-wrap flex-column p-3 mb-2 border-bottom-1"
                        >
                          {/* Last Updated Information */}

                          <div className="d-flex flex-wrap justify-content-between align-items-center flex-wrap ">
                            {/* Question and Answer Section */}

                            <div className="col-lg-10">
                              <small className="text-muted mb-4 font-size-14">
                                Last Updated:{" "}
                                {new Date(
                                  question?.ModifiedDate
                                ).toLocaleString()}
                              </small>
                              <h4 className="mt-2 ">{`${"Question"} ${
                                // question.QuestionID
                                question?.QuestionNo
                                } : ${question?.SecurityQuestion}`}</h4>
                              <p>
                                <strong>Your Answer : </strong>{" "}
                                {!isEditSQ || sqindex !== index ? (
                                  // Show the answer if isEditSQ is false or the index doesn't match
                                  question?.SQAnswer
                                ) : (
                                  // Show the input and buttons if isEditSQ is true and the index matches
                                  <div>
                                    <div className="form-floating mb-3">
                                      <TextInput
                                        placeholder="Enter new answer"
                                        maxLength={50}
                                        value={Squestion[index].SQAnswer}
                                        handleChange={(e) =>
                                          handleEditSQChange(
                                            e.target.value,
                                            index
                                          )
                                        }
                                      />
                                    </div>
                                    <div className="d-flex flex-wrap justify-content-center gap-3 flex-wrap">
                                      <Button
                                        variant="primary"
                                        className="me-2"
                                        label="UPDATE"
                                        type="submit"
                                        icon={"fa-solid fa-pen-to-square"}
                                        status="primary"
                                        disabled={false}
                                        onClick={handleUpdateSecurity}
                                      />
                                      <Button
                                        variant="secondary"
                                        className="me-2"
                                        label="CANCEL"
                                        type="button"
                                        status="secondary"
                                        imgsrc={rejectsrc}
                                        disabled={false}
                                        onClick={handleCancelSequrity}
                                      />
                                    </div>
                                  </div>
                                )}
                              </p>
                            </div>
                            {/* Edit Icon */}
                            {[1, 2, 6, 12]?.includes(user?.UserRoleID) && <div className="">
                              <i
                                style={{ color: "#cc5a5a", cursor: "pointer" }}
                                className="fa-solid fa-pen-to-square"
                                title="Edit"
                                onClick={() =>
                                  handleEditSecurityQuestion(index)
                                }
                              ></i>
                            </div>}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </>
              <div className="accordion-body fs-5 p-2 m-2">
                <h4 className="inner-header-bg text-color">
                  <i className="fa fa-hourglass-half me-2"></i> Inmate
                  Connection Request{" "}
                </h4>

                <div className="row">
                  {/* Global Setup Card */}
                  <div className="col-lg-6  mb-3">
                    <div className="card inmatecard-height">
                      <span className=" form-title">
                        Global Setup - Connection Request
                      </span>
                      <div className="card-body">
                        <div className="p-1 m-0 ">
                          <div className="col-md-6 mb-2">
                            <label
                              className="fs-5"
                              style={{ minWidth: "100px" }}
                            >
                              Frequency{" "}
                            </label>
                            <label className="fs-5">: </label>
                            <strong className="fs-5 text-end p-2">
                              {inmateInfoTabData[0]
                                ?.FacilityInmateInvitePublicFrequencyType === 0
                                ? "Nil"
                                : inmateInfoTabData[0]
                                  ?.FacilityInmateInvitePublicFrequencyType ===
                                  1
                                  ? "Daily"
                                  : inmateInfoTabData[0]
                                    ?.FacilityInmateInvitePublicFrequencyType ===
                                    2
                                    ? "Weekly"
                                    : "Monthly"}
                            </strong>
                          </div>
                          <div className="col-md-6">
                            <label
                              className="fs-5"
                              style={{ minWidth: "100px" }}
                            >
                              Limit{" "}
                            </label>
                            <label className="fs-5">: </label>
                            <strong className="fs-5 text-end p-2">
                              {inmateInfoTabData[0]
                                ?.FacilityInmateInvitePublicCount === 0
                                ? "Nil"
                                : inmateInfoTabData[0]
                                  ?.FacilityInmateInvitePublicCount}
                            </strong>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Individual Setup Card */}
                  <div className="col-lg-6  mb-3">
                    <div className="card inmatecard-height">
                      <span className=" form-title">
                        Individual Setup - Connection Request
                      </span>
                      <div className="card-body">
                        <form>
                          <div className="row">
                            <div className="col-lg-6 mb-3">
                              <SelectInput
                                name="InmateInvitePublicFrequencyType"
                                id="InmateInvitePublicFrequencyType"
                                label="Select Frequency"
                                options={settingsFrequency}
                                handleChange={(selectedOption) =>
                                  handleSelectChange(
                                    selectedOption,
                                    "InmateInvitePublicFrequencyType"
                                  )
                                }
                                value={
                                  inmateInfo?.InmateInvitePublicFrequencyType
                                }
                                placeholder="Frequency"
                                required={true}
                                maxLength={50}
                                isClearable={false}
                                errorMessage={errorMessage}
                                disabled={isDisabledInmate}
                                handleBlur={handleBlurFrequencyType}
                              />
                            </div>
                            <div className="col-lg-6 mb-1">
                              <TextInput
                                label="Limit"
                                name="InmateInvitePublicCount"
                                value={
                                  inmateInfo?.InmateInvitePublicCount || ""
                                }
                                handleChange={handleChangeText}
                                showImage={false}
                                required={true}
                                maxLength={3}
                                errorMessage={errorLimit}
                                disabled={isDisabledInmate}
                                handleBlur={MaxLimit}
                                placeholder="Enter Limit"
                              />
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="accordion-body fs-5 p-2 m-2">
                <h4 className="inner-header-bg text-color">
                  <i className="fa-solid fa-book me-2"></i> New Note
                </h4>
                <div className="row">
                  <div className="col-12">
                    <TextAreaInput
                      name="Notes"
                      id="Notes"
                      label="Note"
                      value={inmateInfo?.Notes} // Replace with the value for the text area
                      handleChange={handleChangeText} // Replace with your change handler function
                      placeholder="Enter user notes"
                      required={false} // Set as needed
                      rows={4} // Number of rows for the textarea
                      disabled={
                        isDisabledInmate
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="accordion-body fs-5 p-2 m-2">
                <h4 className="inner-header-bg text-color">
                  <i className="fa-solid fa-envelope me-2"></i>Investigator
                  e-mail{" "}
                </h4>
                <div className="col-md-12">
                  <div className="form-floating">
                    <TextInput
                      name="InvestigatorEmail"
                      id="InvestigatorEmail"
                      label="Investigator e-mail"
                      value={inmateInfo?.InvestigatorEmail}
                      handleChange={handleChangeText}
                      required={false}
                      // disabled={true}
                      errorMessage={errorMessage}
                      disabled={
                        isDisabledInmate
                      }
                    />
                  </div>
                </div>
                <div className="fs-5">
                  <p className="fst-italic">
                    Note : To include multiple investigator e-mail seperate by
                    comma ( , )
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="accordion" id="accordion-connection">
        <div className="accordion-item border-0">
          <div className="card mb-3">
            <div className="accordion-header" id="headingConnection">
              <button
                className={`accordion-button 
                ${!connectionCheckBox ? "collapsed" : ""} 
              text-black fs-4 fw-bold px-3 py-2 pointer-cursor border-grey w-100`}
                type="button"
                aria-expanded={true}
                onClick={() =>
                  handleAccordian(
                    { target: { checked: !connectionCheckBox } },
                    3
                  )
                }
              >
                Connections
                {/* <span className="d-flex flex-wrap justify-content-between align-items-center w-100">
                  <CheckBoxInput
                    label="Connections"
                    name="connectionCheckBox"
                    id="connectionCheckBox"
                    handleClick={(e) => handleAccordian(e, 3)}
                    value={connectionCheckBox}
                    checked={connectionCheckBox}
                  />
                </span> */}
              </button>
            </div>
            <div
              id="connection-accordion"
              className={`accordion-collapse ${connectionCheckBox ? "show" : "collapse"
                }`}
              aria-labelledby="headingConnection"
            >
              <div className="accordion-body fs-5 p-2 m-2">
                <div className="mb-3">
                  <div className="mb-3">
                    <div className="d-flex flex-wrap justify-content-start gap-3">
                      {/* <h4 className="fw-bold">Public Users</h4> */}
                      <h4 className="inner-subheader-bg text-color">
                        <i className="fa-solid fa-user me-2"></i> Public Users
                      </h4>
                      <div className="ms-auto">
                        {connectionDataList?.DataList?.length > 0 && (
                          <ExcelExport
                            handleExcelExport={handleConnectionExcel}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  <Table
                    columns={connectionColumn}
                    data={connectionDataList?.DataList}
                    pagination
                    onChangeRowsPerPage={handleConnectionRowPerPage}
                    onChangePage={handleConnectionPageChange}
                    totalRowCount={connectionDataList?.TotalRecordCount}
                    currentPage={connection?.PageNo}
                    paginationPerPage={connection.RowCountPerPage}
                    onSort={handleSort}
                    serverSideSort
                    sortColumn={connection?.SortField?.split(" ")[0]}
                    sortDirection={connection?.SortField?.split(" ")[1]}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="accordion" id="accordion-loginInfo">
        <div className="accordion-item border-0">
          <div className="card mb-3">
            <div className="accordion-header" id="headingLoginInfo">
              <button
                className={`accordion-button 
                ${loginInfoCheckBox ? "" : "collapsed"} 
              text-black fs-4 fw-bold px-3 py-2 pointer-cursor border-grey w-100`}
                type="button"
                aria-expanded={true}
                onClick={() =>
                  handleAccordian(
                    { target: { checked: !loginInfoCheckBox } },
                    4
                  )
                }
              >
                {" "}
                Login Information
                {/* <span className="d-flex flex-wrap justify-content-between align-items-center w-100">
                  <CheckBoxInput
                    label="Login Info"
                    name="loginInfoCheckBox"
                    id="loginInfoCheckBox"
                    handleClick={(e) => handleAccordian(e, 4)}
                    value={loginInfoCheckBox}
                    checked={loginInfoCheckBox}
                  />
                </span> */}
              </button>
            </div>
            <div
              id="loginInfo-accordion"
              className={`accordion-collapse ${loginInfoCheckBox ? "show" : "collapse"
                }`}
              aria-labelledby="headingLoginInfo"
            >
              <div className="accordion-body fs-5 p-2 m-2">
                <div className="mb-3">
                  <div className="mb-3">
                    <div className="d-flex flex-wrap justify-content-start gap-3">
                      {/* <h4 className="fw-bold">Login Info</h4> */}
                      <h4 className="inner-subheader-bg text-color">
                        <i className="fa-solid fa-circle-info me-2"></i> Login
                        Info
                      </h4>
                      <div className="ms-auto">
                        {loginLogHistory?.DataList?.length > 0 && (
                          <ExcelExport handleExcelExport={handleLoginExport} />
                        )}
                      </div>
                    </div>
                  </div>
                  <Table
                    columns={loginColumn}
                    data={loginLogHistory?.DataList}
                    pagination
                    onChangeRowsPerPage={handleLoginInfoRowPerPage}
                    onChangePage={handleLoginInfoPageChange}
                    totalRowCount={loginLogHistory?.TotalRecordCount}
                    currentPage={loginInfo?.PageNo}
                    paginationPerPage={loginInfo.RowCountPerPage}
                    serverSideSort
                    onSort={handleLoginSort}
                    sortColumn={loginInfo?.SortBy?.split(" ")[0]}
                    sortDirection={loginInfo?.SortBy?.split(" ")[1]}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {user?.UserRoleID !== 13 && (
        <div className="d-flex flex-wrap justify-content-center gap-3 flex-wrap">
          <Button
            variant="primary"
            className="me-2"
            label="UPDATE"
            type="submit"
            icon={"fa-solid fa-pen-to-square"}
            status="primary"
            disabled={false}
            isdisabled={isDisabledInmate}
            onClick={handleSubmit}
          />

          <Button
            variant="secondary"
            className="me-2"
            label="RESET"
            type="button"
            icon={"fa-solid fa-rotate-right"}
            status="secondary"
            disabled={false}
            onClick={handleReset}
          />
        </div>
      )}
    </div>
  );
}

export default React.memo(InmateInfo);
